export type Language = 'fr' | 'en' | 'es';

export const appTranslations: Record<Language, AppTranslations> = {
  fr: {
    // Sidebar
    sidebar: {
      menu: 'Menu',
      system: 'Système',
      sectionOverview: 'Vue d’ensemble',
      sectionKnowledges: 'Connaissances',
      sectionAgentsDiscussions: 'Agents & Messenger',
      sectionAdvanced: 'Avancé',
      advancedMore: 'Plus',
      advancedLess: 'Moins',
      badgePreview: 'Aperçu',
      badgeBeta: 'Bêta',
      sharedApiKeys: 'Clés API partagées',
      dashboard: 'Tableau de bord',
      knowledges: 'Bases de connaissances',
      agents: 'Agents IA',
      memory: 'Mémoire des agents',
      endUsers: 'Utilisateurs finaux',
      conversations: 'Conversations',
      email: 'E-mails',
      workflows: 'Automatisations',
      messenger: 'Messenger',
      agencyDashboard: 'Espace agence',
      admin: 'Administration',
      configuration: 'Configuration',
      myAccount: 'Mon compte',
      logout: 'Déconnexion',
      openMenu: 'Ouvrir le menu',
      closeMenu: 'Réduire le menu',
    },
    // Header / Profile
    header: {
      profile: 'Profil',
      connected: 'Connecté',
      startGuide: 'Guide de démarrage',
      documentation: 'Documentation',
      contactUs: 'Nous contacter',
      myAccount: 'Mon compte',
      logout: 'Déconnexion',
    },
    // Page titles
    pageTitles: {
      dashboard: 'Tableau de bord',
      conversations: 'Conversations',
      conversationHistory: 'Historique',
      agents: 'Agents IA',
      knowledges: 'Base de connaissances',
      library: 'Bibliothèque',
      catalog: 'Catalogue',
      administration: 'Administration',
      widgetConfig: 'Configuration des Widgets',
      branding: 'Branding',
      sendgrid: 'SendGrid Notifications',
      publicAgent: 'Agent Public',
      systemPrompts: 'Prompts Système',
      paymentStripe: 'Payment Stripe',
      ollamaCloud: 'Ollama Cloud',
      configuration: 'Configuration',
      wordpress: 'WordPress',
      openai: 'OpenAI',
      anthropic: 'Anthropic',
      sendgridAgent: 'SendGrid (réponses email)',
      users: 'Utilisateurs',
      models: 'Modèles',
      integrations: 'Intégrations',
      mcp: 'MCP',
      monitoring: 'Monitoring',
      logs: 'Logs',
      logsMcp: 'Logs MCP',
      profile: 'Profil',
      twoFA: 'Authentification 2FA',
      workflows: 'Workflows',
      planManagement: 'Gestion des Plans',
      adminUsers: 'Utilisateurs Admin',
      adminAffiliate: 'Affiliation',
      pricing: 'Tarifs',
      myAccountPage: 'Mon Compte',
      memory: 'Mémoire',
      endUsers: 'End-Users',
      email: 'Email',
    },
    affiliate: {
      navLabel: 'Parrainage',
      title: 'Programme de parrainage',
      subtitle: 'Partagez Totemium et gagnez une commission sur les abonnements éligibles.',
      yourCode: 'Votre code',
      yourLink: 'Lien à partager',
      copy: 'Copier',
      copied: 'Copié',
      referrals: 'Filleuls',
      payable: 'À payer (estimation)',
      paid: 'Déjà versé',
      connectNote: 'Versement',
      commissionsTitle: 'Historique des commissions',
      emptyCommissions: 'Aucune commission pour le moment.',
      plan: 'Plan',
      amount: 'Montant',
      docsLink: 'Conditions du programme',
      recurringOn: 'Commission sur chaque renouvellement',
      recurringOff: 'Commission sur le premier paiement du filleul uniquement',
      contractTitle: 'Contrat d’affiliation',
      contractSubtitle:
        'Les plateformes SaaS exigent en général une acceptation explicite des conditions avant de promouvoir le service. Lisez le texte ci-dessous puis validez.',
      contractVersionLabel: 'Version du contrat',
      contractAcceptCheckbox:
        'Je confirme avoir lu et accepté ce contrat ainsi que les règles du programme d’affiliation.',
      contractAcceptButton: 'Accepter et continuer',
      contractEmpty: '_Aucun texte configuré par l’administrateur._',
      holdPeriodNote:
        'Délai avant paiement : {days} jours après l’enrôlement du filleul (date d’attribution).',
      linkHiddenUntilContract: 'Acceptez le contrat ci-dessus pour afficher votre code et votre lien.',
      pendingHold: 'En attente (délai)',
      pendingHoldHint: 'Montant dont le délai post-enrôlement n’est pas encore écoulé.',
      payableAt: 'Payable à partir du',
      dashboardPrivacyNote:
        'Confidentialité : vous voyez uniquement un identifiant technique interne pour chaque filleul ; l’identité réelle est traitée côté Totemium.',
      referralsSectionTitle: 'Mes filleuls',
      referredUserIdColumn: 'ID filleul',
      referredUserIdTooltip:
        'Identifiant interne du filleul dans Totemium (non nominatif). Le support peut relier cet ID à un compte si nécessaire.',
      referredUserIdHint:
        'Les filleuls sont listés avec un identifiant interne uniquement, conformément à notre politique de confidentialité.',
      attributedAt: 'Date d’attribution',
      source: 'Source',
      commissionsCount: 'Commissions',
      totalCommissionCents: 'Total commissions',
      lastCommissionAt: 'Dernière commission',
      hasPaidBadge: 'Déjà payée',
      emptyReferrals: 'Aucun filleul enregistré pour le moment.',
      exportReferralsCsv: 'Exporter CSV',
      chartTitle: 'Commissions par mois',
      chartEmpty: 'Pas encore de série mensuelle (commissions enregistrées).',
      statsAttributedLabel: 'Attributions (total)',
      statsWithCommissionLabel: 'Filleuls avec au moins une commission',
      linkViewsSectionTitle: 'Vues du lien de parrainage',
      linkViewsHint:
        'Une vue est enregistrée à chaque première ouverture du lien avec ?ref= dans un navigateur (session). Le site d’origine (référent HTTP) et les UTM sont indiqués quand le navigateur les envoie.',
      linkViewsTotal: 'Vues du lien (total)',
      linkViewsLast30: 'Vues (30 derniers jours)',
      linkViewsChartTitle: 'Vues par mois',
      linkViewsShort: 'Vues',
      topReferrersTitle: 'Provenance (sites référents)',
      columnReferrerDomain: 'Origine',
      columnViewCount: 'Vues',
    },
    modelsPlatformAdmin: {
      pageTitle: 'Modèles LLM (plateforme)',
      pageSubtitle:
        'Ollama : téléchargez les modèles sur le serveur. Pour chaque fournisseur, activez les modèles offerts aux tenants (filtre global, puis affinage par workspace). Par défaut, OpenAI et Anthropic sont tous désactivés tant que vous n’activez pas les interrupteurs.',
      tabOllama: 'Ollama',
      tabOpenai: 'OpenAI',
      tabAnthropic: 'Anthropic',
      save: 'Enregistrer les sélections',
      saving: 'Enregistrement…',
      loadError: 'Impossible de charger le catalogue plateforme',
      saveError: 'Impossible d’enregistrer',
      tenantSwitch: 'Offert aux tenants',
      sortLabel: 'Ordre',
      pullTitle: 'Télécharger un modèle',
      pullPlaceholder: 'ex: llama3.2:3b',
      pullButton: 'Télécharger (stream)',
      pulling: 'Téléchargement…',
      pullStorageHint: 'Stockage côté serveur Ollama (ex. /var/lib/totemai/ollama/).',
      backAdmin: 'Retour administration',
      colName: 'Nom',
      colSize: 'Taille',
      colModified: 'Modifié',
      colDigest: 'Digest',
      colActions: 'Actions',
      defaultBadge: 'Défaut',
      setDefault: 'Définir défaut',
      currentDefault: 'Modèle par défaut actuel : {name}',
      deleting: 'Suppression…',
      delete: 'Supprimer',
      noModels: 'Aucun modèle local.',
      loading: 'Chargement…',
    },
    adminAffiliate: {
      title: 'Programme d’affiliation',
      subtitle: 'Paramètres en base, parrains, attributions, commissions et Stripe Connect.',
      tabSettings: 'Paramètres',
      tabReferrers: 'Parrains',
      tabAttributions: 'Attributions',
      tabCommissions: 'Commissions',
      programEnabled: 'Programme actif',
      commissionRateBps: 'Taux (basis points, ex. 1500 = 15 %)',
      recurringCommissions: 'Commission sur chaque renouvellement',
      maxCommissionMonths: 'Fenêtre commissions (mois, 0 = illimité)',
      minInvoiceCents: 'Montant minimum facture (centimes)',
      payableAfterReferralDays: 'Délai avant « payable » (jours après enrôlement filleul)',
      payableAfterReferralHint:
        '0 = immédiat dès facture. Ex. 60 = commissions en attente jusqu’à 60 jours après la date d’attribution (first-touch). Courant pour réduire le risque remboursement.',
      contractSection: 'Contrat affiliés (acceptation obligatoire si texte renseigné)',
      contractVersion: 'Version du contrat (incrémentez pour forcer une nouvelle acceptation)',
      contractVersionHint: 'Pratique SaaS : nouvelle version = tous les affiliés doivent ré-accepter.',
      contractMarkdown: 'Texte du contrat (Markdown)',
      contractMarkdownPlaceholder:
        'Remplacez les {{PLACEHOLDERS}} ; un modèle est préchargé si le champ était vide.',
      pendingHoldStatus: 'En attente délai (pending_hold)',
      payableAt: 'Payable à partir du',
      excludedPlanSlugs: 'Plans exclus (slugs séparés par des virgules)',
      cookieName: 'Nom du cookie de parrainage',
      cookieMaxAge: 'Durée du cookie (secondes, min. 60)',
      stripeConnectPayouts: 'Versements automatiques Stripe Connect (Transfer)',
      stripeConnectCountry: 'Pays par défaut comptes Express (ISO2)',
      defaultPayoutCurrency: 'Devise du ledger (ISO3)',
      emailSearch: 'Filtrer par e-mail',
      emailColumn: 'E-mail',
      publicCode: 'Code',
      referralsCount: 'Filleuls',
      payableCents: 'Payable (¢)',
      paidCents: 'Payé (¢)',
      suspend: 'Suspendre',
      activate: 'Réactiver',
      rotateCode: 'Nouveau code',
      stripeOnboarding: 'Onboarding Stripe',
      total: 'Total',
      prev: 'Précédent',
      next: 'Suivant',
      createAttribution: 'Créer l’attribution',
      attributionsCreateTitle: 'Nouvelle attribution',
      attributionsCreateHint:
        'Lie manuellement un parrain à un filleul. Renseignez l’ID ou l’e-mail pour chaque côté (au moins un des deux par personne).',
      attributionsCreateNeedBoth:
        'Indiquez un identifiant (ID ou e-mail) pour le parrain et pour le filleul.',
      attributionsFilterTitle: 'Filtrer la liste',
      attributionsFilterHint:
        'Affinez par ID et/ou e-mail ; laissez vide pour tout afficher. ID et e-mail pour un même rôle doivent correspondre au même compte.',
      attributionsResetFilters: 'Réinitialiser les filtres',
      attributionsListTitle: 'Attributions enregistrées',
      newReferrerId: 'ID parrain',
      newReferredId: 'ID filleul',
      newReferrerEmail: 'E-mail parrain',
      newReferredEmail: 'E-mail filleul',
      filterReferrerId: 'Filtre ID parrain',
      filterReferredId: 'Filtre ID filleul',
      filterReferrerEmail: 'Filtre e-mail parrain',
      filterReferredEmail: 'Filtre e-mail filleul',
      suspended: 'Suspendu',
      stripeTransfer: 'Transfert Stripe',
      markPaidStripe: 'Virement Stripe',
      filterStatus: 'Statut',
      allStatuses: 'Tous',
      payableOnly: 'Payable seulement',
      exportCsv: 'Export CSV',
      refresh: 'Actualiser',
      markPaid: 'Marquer payé',
      payoutRef: 'Référence de virement',
      payoutRefPlaceholder: 'ex. virement 2026-04-05',
      referrer: 'Parrain',
      referred: 'Filleul',
      invoice: 'Facture Stripe',
    },
    // Footer
    footer: {
      rights: 'Tous droits réservés.',
    },
    // Common
    common: {
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      create: 'Créer',
      search: 'Rechercher',
      loading: 'Chargement...',
      noResults: 'Aucun résultat',
      confirm: 'Confirmer',
      back: 'Retour',
      next: 'Suivant',
      close: 'Fermer',
      yes: 'Oui',
      no: 'Non',
      actions: 'Actions',
      status: 'Statut',
      name: 'Nom',
      description: 'Description',
      date: 'Date',
      type: 'Type',
      active: 'Actif',
      inactive: 'Inactif',
      enabled: 'Activé',
      disabled: 'Désactivé',
      selectLanguage: 'Choisir la langue',
      irreversibleAction: 'Cette action est irréversible.',
      confirmDeletePrefix: 'Êtes-vous sûr de vouloir supprimer',
      errorWhileDeleting: 'Erreur lors de la suppression',
      deleteInProgress: 'Suppression...',
      deletePermanently: 'Supprimer définitivement',
    },

    dashboard: {
      loadStatsError: 'Erreur chargement stats',

      cards: {
        indexedMediaTitle: 'Médias indexés',
        indexedMediaDescription: 'Nombre total de fichiers traités',
        embeddingsTitle: 'Embeddings',
        embeddingsDescription: 'Vecteurs disponibles pour le RAG',
        trackedStatusesTitle: 'Statuts suivis',
        trackedStatusesDescription: 'États de traitement actifs',
        linkedCoursesTitle: 'Formations reliées',
        linkedCoursesDescription: 'Cours ou parcours connectés',
      },

      recent: {
        title: 'Derniers médias ingérés',
        description: 'Trois derniers contenus traités. Suivez leur statut et la formation associée.',
        table: {
          title: 'Titre',
          status: 'Statut',
          course: 'Formation',
          date: 'Date',
        },
        empty: 'Aucun média disponible pour le moment.',
      },

      activity: {
        title: 'Activité 7 derniers jours',
        totalDescription: 'Total des médias traités sur les sept derniers jours.',
      },

      statuses: {
        title: 'Statuts actifs',
        empty: 'Aucun statut suivi.',
      },
    },

    agencyDashboard: {
      title: 'Dashboard Agency',
      subtitle: 'Vue globale de tous vos workspaces',
      loading: 'Chargement...',
      error: 'Erreur lors du chargement des données',
      notAgency: 'Cette page est réservée aux utilisateurs du plan Agency',
      upgradeButton: 'Passer au plan Agency',
      pooledQuotas: 'Quotas poolés',
      pooledQuotasDescription: 'Vos quotas (agents, conversations, stockage) sont partagés entre tous vos workspaces. Le total affiché représente l\'utilisation globale de votre compte Agency.',
      unlimited: 'Illimité',
      thisMonth: 'ce mois',
      items: 'éléments',
      workspace: 'workspace',
      workspaces: 'workspaces',
      plan: 'Plan',
      preview: 'Aperçu',
      production: 'Production',
      
      globalMetrics: {
        title: 'Métriques globales',
        agents: 'Agents',
        storage: 'Stockage',
        workspaces: 'Workspaces',
        conversations: 'Conversations',
        knowledge: 'Connaissances',
        of: 'sur',
      },

      workspacesList: {
        title: 'Vos workspaces',
        name: 'Nom',
        agents: 'Agents',
        storage: 'Stockage',
        conversations: 'Conversations',
        knowledgeItems: 'Connaissances',
        createdAt: 'Créé le',
        mode: 'Mode',
        preview: 'Aperçu',
        production: 'Production',
      },
    },

    knowledges: {
      tagline: 'Gérez vos collections et contenus pour enrichir vos assistants IA',
      collections: 'Collections',
      stats: 'Statistiques',
      syncs: 'Synchronisations',

      panel: {
        orphanTitle: 'Contenus sans collection',
        contentsOfPrefix: 'Contenus de',
        allContents: 'Tous les contenus',
        contentCount: 'contenu',
      },

      collectionsSidebar: {
        allContents: 'Tous les contenus',
        withoutCollection: 'Sans collection',
        newCollection: 'Nouvelle collection',
        manual: 'Manuel',
        wordpress: 'WordPress',
        deleteCollectionTitle: 'Supprimer la collection',
        deleteCollectionWarning: 'Les contenus associés ne seront pas supprimés mais deviendront orphelins.',
      },

      collectionCreate: {
        title: 'Nouvelle collection',
        subtitle: 'Créez un regroupement pour organiser vos contenus',
        collectionTitleLabel: 'Titre de la collection',
        placeholder: 'Ex: Formation onboarding',
        titleRequired: 'Le titre est requis',
        creationError: 'Erreur lors de la création',
        creating: 'Création...',
        create: 'Créer la collection',
        tipsTitle: 'Conseils',
        tip1: 'Regroupez par thématique ou formation pour plus de clarté.',
        tip2: 'Les collections WordPress sont synchronisées automatiquement.',
        tip3: 'Vous pourrez renommer ou supprimer cette collection plus tard.',
        kbLanguageLabel: 'Langue des contenus (recherche RAG)',
        kbLanguageHint: 'Indique dans quelle langue sont rédigés les documents ; la réponse à l\'utilisateur peut rester dans sa propre langue.',
      },

      kbContentLanguage: {
        label: 'Langue des documents',
        hint: 'Améliore la pertinence du RAG. Laissez vide pour utiliser le défaut plateforme (Phase suivante du produit).',
        autoOption: 'Automatique / non défini',
        langFr: 'Français (fr)',
        langEn: 'Anglais (en)',
        langEs: 'Espagnol (es)',
        langDe: 'Allemand (de)',
        langIt: 'Italien (it)',
        langPt: 'Portugais (pt)',
        langNl: 'Néerlandais (nl)',
        langZhHans: 'Chinois simplifié (zh-hans)',
        sidebarTitle: 'KB',
      },

      contentsPanel: {
        allStatuses: 'Tous les statuts',
        indexed: 'Indexés',
        transcribed: 'Transcrits',
        pending: 'En attente',
        transcribing: 'Transcription...',
        indexing: 'Indexation...',
        inError: 'En erreur',
        addContentShort: '+ Contenu',
        emptyTitle: 'Aucun contenu',
        emptyOrphan: 'Tous vos contenus sont associés à une collection.',
        emptyDefault: 'Ajoutez votre premier contenu pour enrichir cette collection.',
        addFirstContent: '+ Ajouter un contenu',
        deleteContentTitle: 'Supprimer le contenu',
        deleteContentWarning: 'Les transcriptions, embeddings et métadonnées seront définitivement supprimés.',
      },

      contentCard: {
        indexedAtPrefix: 'Indexé',
        viewDetails: 'Voir détails',
        reindexClassic: 'Ré-indexer (chunking classique)',
        alreadyLLMSegmented: 'Déjà segmenté par IA',
        llmSegmentation: 'Segmentation IA (meilleure qualité RAG)',
        forceTranscribe: 'Forcer transcription',
        yesterday: 'hier',
        justNow: "à l'instant",
        minutesAgo: 'il y a {n} min',
        hoursAgo: 'il y a {n}h',
        daysAgo: 'il y a {n}j',
      },

      contentDetail: {
        titleFallback: 'Détails du contenu',
        cannotLoadDetails: 'Impossible de charger les détails',
        collection: 'Collection',
        withoutCollection: 'Sans collection',
        move: 'Déplacer',
        currentlyInPrefix: 'Actuellement dans :',
        categories: 'Catégories',
        course: 'Formation',
        chunks: 'Chunks',
        embeddings: 'Embeddings',
        file: 'Fichier',
        size: 'Taille',
        mb: 'Mo',
        embeddingsByCategory: 'Embeddings par catégorie',
        transcription: 'Transcription',
        characters: 'caractères',
        language: 'Langue',
        noTranscription: '— Aucune transcription disponible —',
        transcriptionUnavailable: 'Transcription indisponible',
        downloadTranscription: 'Télécharger la transcription',
        downloadTxt: 'Télécharger .txt',
        reindex: 'Ré-indexer',
        llmSegmentation: 'Segmentation IA',
        forceTranscribe: 'Forcer transcription',
      },

      statsDrawer: {
        title: 'Statistiques',
        subtitle: "Vue d'ensemble de votre base de connaissances",
        collections: 'Collections',
        contents: 'Contenus',
        total: 'Total',
        manuals: 'Manuelles',
        wordpress: 'WordPress',
        orphanContents: 'Contenus orphelins',
        ready: 'Prêts',
        indexed: 'Indexés',
        transcribed: 'Transcrits',
        processing: 'En traitement',
        pending: 'En attente',
        errors: 'En erreur',
        globalHealth: 'Santé globale',
        usableContents: 'Contenus exploitables',
        healthHint: '{ready} contenus sur {total} sont prêts à être utilisés par vos agents.',
        byStatus: 'Répartition par statut',
      },

      wpImport: {
        title: 'Importer depuis WordPress',
        chooseContentType: 'Choisissez le type de contenu',
        selectContentsPrefix: 'Sélectionnez les',
        confirmImport: "Confirmez l'import",
        importing: 'Import en cours...',
        completed: 'Import terminé',
        error: 'Erreur',
        availableQuota: 'Quota disponible',
        credits: 'crédits',
        selected: 'sélectionné',
        continue: 'Continuer →',
        quotaEnough: '✓ Quota suffisant',
        quotaNotEnough: '✗ Quota insuffisant ({n} contenus en trop)',
        back: 'Retour',
        launching: 'Lancement...',
        importN: 'Importer {n} contenu{s}',
        editSelection: 'Modifier la sélection',
        importSummary: "Résumé de l'import",
        selectedContents: 'Contenus sélectionnés',
        totalChars: 'Total caractères',
        requiredCredits: 'Crédits requis',
        creditsAfter: 'Crédits après import',
        quotaAfter: 'Quota après import',
        importPossible: '✅ Import possible',
        quotaExceeded: '⚠️ Quota dépassé de {n} crédits',
        importOptions: "Options d'import",
        destinationCollection: 'Collection de destination',
        autoCreate: 'Créer automatiquement',
        autoCreateFromCourses: 'Créer des collections depuis les cours WordPress',
        items: 'éléments',
        item: 'élément',
        notAvailable: '(non disponible)',
        selectAll: 'Tout sélectionner',
        none: 'Aucun',
        availableSuffix: 'disponibles',
        noTitle: '(Sans titre)',
        modified: 'Modifié',
        imported: 'Importé',
        charCount: '{n} caractères',
        approxChars: '~ caractères',
        loadMore: 'Charger plus',
        cancelImport: "Annuler l'import",
        importWithErrors: 'Import terminé avec des erreurs',
        importDone: 'Import terminé !',
        importedSuccess: '{n} contenu{s} importé{s} avec succès',
        success: 'Réussis',
        failed: 'Échoués',
      },
      upload: {
        title: 'Ajouter un contenu',
        description: 'Importez un nouveau média : il sera automatiquement transcrit puis indexé.',
        close: 'Fermer',
        collection: 'Collection',
        course: 'Formation WordPress (optionnel)',
        choose: '— choisir —',
        advice: 'Conseillé : rattachez votre contenu à une collection pour optimiser le RAG.',
        courseHelp: "Si aucune collection n'est sélectionnée, rattachez le média à une formation WordPress.",
        dropzoneTitle: 'Glissez-déposez vos fichiers ici, ou cliquez pour parcourir.',
        formats: 'Formats acceptés : mp3, wav, mp4, mov, txt, md, pdf.',
        filesSelected: '{n} fichier(s) sélectionné(s)',
        uploading: 'Upload en cours…',
        completed: 'Upload terminé',
        upload: 'Uploader',
        reset: 'Réinitialiser',
        footer: 'Les contenus envoyés s\'afficheront dans la bibliothèque après indexation. Surveillez leur statut depuis la page contenus.',
        errorLoadSubjects: 'Erreur chargement des sujets',
        errorSelectFile: 'Choisir au moins un fichier',
        success: '{n} fichier(s) uploadé(s) avec succès',
        partialSuccess: '{success} réussi(s), {error} échec(s)',
        mb: 'Mo',
      },
    },
    agents: {
      title: 'Vos agents',
      tagline: 'Gérez vos agents IA et leur configuration',
      statsDrawerTitle: 'Tableau de bord agents',
      statsDrawerSubtitle: 'Suivez vos quotas et les agents les plus actifs.',
      createAgent: 'Créer un nouvel agent',
      statistics: 'Statistiques',
      loading: 'Chargement des agents…',
      noAgents: 'Aucun agent pour le moment. Créez votre premier assistant en définissant sa personnalité, son icône et ses bases de connaissances.',
      lastUpdated: 'Dernière mise à jour',
      quotaBadge: {
        active: 'actif',
        max: 'max',
        quotaReached: 'Quota atteint',
      },
      deleteModal: {
        title: "Supprimer l'agent",
        warning: 'Cette action retire définitivement l\'agent et ses statistiques.',
        linkedSubjectsWarning: 'L\'agent est lié à {n} sujet(s). Les médias resteront accessibles mais l\'agent ne pourra plus répondre aux conversations.',
        noSubjectsWarning: 'L\'agent sera retiré immédiatement de vos intégrations (chat widget, API, etc.).',
      },
      agentCard: {
        active: 'Actif',
        inactive: 'Inactif',
        messages: 'Messages',
        docs: 'Docs',
        ai: 'IA',
        updated: 'Maj',
        useInChat: 'Utiliser dans le chat',
        history: 'Historique',
        edit: 'Modifier',
        deactivate: 'Désactiver',
        activate: 'Activer',
        mcp: 'MCP',
        assignEmail: 'Assigner email',
        changeIcon: 'Changer icône',
        uploading: 'Upload…',
        delete: 'Supprimer',
        deleting: 'Suppression…',
      },
      stats: {
        activeAgents: 'Agents actifs',
        activeAgentsDesc: 'Agents prêts à répondre dans le chat',
        activeAgentsEmpty: 'Créez votre premier agent personnalisé',
        messagesSent: 'Messages envoyés',
        messagesRemaining: 'Reste {n} messages',
        noLimit: 'Aucun plafond défini',
        globalQuota: 'Quota global',
        limitLabel: 'Limite propriétaire',
        unlimitedPlan: 'Plan sans limite',
        lastUpdate: 'Dernière mise à jour',
        noAgentYet: 'Aucun agent pour le moment',
        recentAgent: 'Agent le plus récent',
        usageGlobal: 'Usage global',
        messagesOrg: 'messages envoyés par l\'organisation',
        totalAgents: 'Total agents',
        knowledgeBases: 'Bases de connaissances',
        aiUsed: 'Intelligences utilisées',
        totalMessagesByAgents: 'Total messages par agents',
        globalQuotaTitle: 'Quota global',
        messagesAllowed: 'messages autorisés',
        utilization: 'Utilisation',
        unlimited: 'Non plafonné',
        remainingMessages: 'Reste {n} messages sur la période.',
        lastAgentCreated: 'Dernier agent créé',
        mostActiveAgents: 'Agents les plus sollicités',
        top5Period: 'Top 5 sur la période courante',
        noMessagesYet: 'Aucun message envoyé pour le moment.',
        maxLabel: 'max',
        noCap: 'Sans plafond',
        docsSuffix: 'doc(s)',
        messagesSuffix: 'messages',
      },
      sandbox: {
        title: 'Agent sandbox',
        subtitle: 'Configurez l\'agent et testez-le dans le playground.',
        quotaPreserved: 'Quota préservé',
        settings: 'Réglages',
        playgroundTitle: 'Playground sandbox',
        playgroundSubtitle: 'Posez vos questions en mode sandbox sans consommer de quota.',
        close: 'Fermer',
        save: 'Enregistrer',
        saving: 'Enregistrement…',
      },
      errors: {
        loadAgents: 'Erreur chargement agents',
        createAgent: 'Erreur création agent',
        updateAgent: 'Erreur mise à jour agent',
        deleteAgent: 'Suppression impossible',
        toggleActivation: 'Erreur lors de l\'activation/désactivation',
        quotaReached: 'Quota d\'agents actifs atteint. Désactivez un agent pour en activer un autre.',
        uploadIcon: 'Erreur upload icône',
      },
      teams: {
        header: 'Équipes',
        allAgents: 'Tous les agents',
        noTeam: 'Sans équipe',
        newTeam: 'Nouvelle équipe',
        deleteTitle: "Supprimer l'équipe",
        deleteWarning: 'Les agents de cette équipe deviendront orphelins (sans équipe).',
        createModal: {
          title: 'Nouvelle équipe',
          subtitle: 'Créez un regroupement pour organiser vos agents',
          close: 'Fermer',
          nameLabel: "Nom de l'équipe",
          namePlaceholder: 'Ex: Support client',
          creating: 'Création...',
          create: "Créer l'équipe",
          errorRequired: 'Le titre est requis',
          errorCreate: 'Erreur lors de la création',
          tipsTitle: 'Conseils',
          tip1: 'Regroupez vos agents par fonction ou département.',
          tip2: 'Les agents sans équipe apparaîtront dans "Sans équipe".',
          tip3: 'Vous pourrez renommer ou supprimer cette équipe plus tard.',
        },
      },
      modelPicker: {
        browse: 'Parcourir…',
        title: 'Choisir un modèle',
        search: 'Rechercher…',
        tabOllama: 'Ollama',
        tabOpenai: 'OpenAI',
        tabAnthropic: 'Anthropic',
        emptyTab: 'Aucun modèle',
        noMatch: 'Aucun résultat',
        apply: 'Valider',
        cancel: 'Annuler',
        loading: 'Chargement…',
      },
      llmCatalog: {
        title: 'Catalogue LLM du workspace',
        subtitle:
          'Cochez les modèles proposés aux membres. Tant qu’aucune offre active n’existe pour un fournisseur, la liste complète reste affichée (comportement par défaut).',
        save: 'Enregistrer',
        saving: 'Enregistrement…',
        loadError: 'Impossible de charger le catalogue',
        saveError: 'Impossible d’enregistrer le catalogue',
        byokNote:
          'OpenAI et Anthropic : une clé API configurée pour ce workspace (BYOK) est nécessaire pour utiliser ces modèles dans les agents.',
        sortLabel: 'Ordre',
        enabledLabel: 'Proposer',
        colModel: 'Modèle',
        noKeyBadge: 'Pas de clé',
        workspaceTab: 'Modèles LLM',
        workspaceTabDesc: 'Offre visible pour les membres',
        errForbidden: 'Vous n’avez pas les droits pour gérer ce catalogue.',
        errPayload: 'Trop d’entrées (limite 500).',
        errUnknownModel: 'Un modèle ou fournisseur est invalide.',
      },
      agentEditor: {
        titleNew: 'Nouvel agent',
        titleEdit: 'Modifier',
        cancel: 'Annuler',
        saving: 'Sauvegarde...',
        save: 'Mettre à jour',
        create: 'Créer',
        tabGeneral: 'Général',
        tabKnowledge: 'Base de connaissances',
        tabMemory: '🧠 Mémoire',
        sectionGeneral: 'Informations générales',
        nameLabel: 'Nom',
        namePlaceholder: 'Ex: Agent support',
        subtitleLabel: 'Sous-titre',
        subtitlePlaceholder: 'Ex: Expert support Totemium',
        iconLabel: 'Icône',
        chooseImage: 'Choisir une image',
        instructionsLabel: 'Instructions',
        instructionsPlaceholder: "Décrivez le rôle et le comportement de l'agent...",
        hideTemplates: '✕ Masquer les templates',
        changeTemplate: '📚 Changer de template',
        messageLimitLabel: 'Limite de messages',
        messageLimitPlaceholder: 'Illimité',
        messageLimitHelp: 'Nombre max de messages par conversation',
        sectionAI: 'Intelligence artificielle',
        modelLabel: '🧠 Modèle IA',
        modelDefault: 'Défaut (système)',
        topKLabel: 'Top K (RAG)',
        topKHelp: 'Défaut: 10 — Plus élevé = plus de contexte mais plus lent',
        rerankLabel: 'Rerank Top N',
        rerankHelp: 'Défaut: 5 — Nombre de documents les plus pertinents gardés',
        strictLabel: '🎯 Réponses strictes',
        strictHelp: "L'assistant ne répondra QU'avec les informations de votre base de connaissances",
        sectionTeam: 'Équipe',
        teamLabel: 'Assigner à une équipe',
        teamNone: 'Aucune équipe',
        sectionAdminPrompt: '🔧 Admin: System Prompt',
        adminPromptLabel: 'Override du prompt système',
        adminPromptDefault: 'Prompt par défaut',
        adminPromptHelp: 'Réservé admin — remplace le prompt système global',
        sectionKnowledge: 'Base de connaissances',
        knowledgeHelp: "Sélectionnez les documents que l'agent peut consulter pour répondre aux questions",
        noKnowledge: 'Aucune base de connaissances disponible',
        noKnowledgeHint: 'Créez des sujets dans la section Documents',
        selected: 'Sélectionnés',
        sectionMemory: '🧠 Mémoire Perpétuelle',
        memoryBusiness: '💼 Mémoire Business (Tenant)',
        memoryBusinessHelp: 'Active la mémoire partagée pour vos connaissances métier et préférences',
        memoryEndUser: '👤 Mémoire End-User (Clients)',
        memoryEndUserHelp: 'Mémorise des informations spécifiques par client identifié',
        scopesTitle: '📚 Scopes Assignés',
        noScopes: 'Aucun scope disponible. Créez-en un sur la page',
        scopeMemoryLink: 'Mémoire',
        scopeNoneSelected: '💡 Aucun scope sélectionné - tous les scopes business seront utilisés',
        scopeSelected: '✓ {n} scope(s) sélectionné(s)',
        memoryPageHint: '💡 Gérez vos scopes et faits mémoire dans la page',
        errorNameRequired: 'Le nom est requis',
        errorSave: 'Erreur lors de la sauvegarde',
        agentTypeLabel: '🎭 Type d\'agent',
        agentTypePlaceholder: 'Choisir un type d\'agent...',
        templateRecommended: 'Templates recommandés',
        templateOthers: 'Autres templates',
        templateCount: '{n} template{s} disponible{s}',
        templateNoAvailable: 'Aucun template disponible pour ce type d\'agent',
        templateTipTitle: 'Astuce',
        templateTipBody: 'Vous pouvez utiliser un template comme base et le personnaliser ensuite dans le champ Instructions. Les templates sont optimisés pour chaque type d\'agent.',
        levelBasic: 'Basique',
        levelAdvanced: 'Avancé',
        levelPremium: 'Premium',
        badgeRecommended: 'Recommandé',
        badgeUsed: 'Utilisé',
        btnPreview: 'Aperçu',
        btnHide: 'Masquer',
        btnUse: 'Utiliser',
        labelPopularity: 'Popularité',
      },
    },
    conversations: {
      title: 'Conversations',
      historyForAgent: 'Historique · {name}',
      backToAgents: 'Agents',
      loading: 'Chargement des conversations...',
      errorLoading: 'Erreur lors du chargement des conversations',
      noConversations: 'Aucune conversation',
      searchPlaceholder: 'Rechercher...',
      filters: 'Filtres',
      hideFilters: 'Masquer',
      allSources: 'Tous',
      whatsApp: 'WhatsApp',
      widgetExt: 'Widget Ext',
      widgetInt: 'Widget Int',
      filteredBy: 'Filtré par :',
      allAgents: 'Tous les agents',
      allUsers: 'Tous les utilisateurs',
      allPeriods: 'Toute période',
      today: 'Aujourd\'hui',
      thisWeek: 'Cette semaine',
      thisMonth: 'Ce mois',
      allMessages: 'Tous les messages',
      short: 'Courtes (1-3 msg)',
      medium: 'Moyennes (4-10 msg)',
      long: 'Longues (10+ msg)',
      sortBy: {
        updatedAt: 'Dernière activité',
        createdAt: 'Date création',
        title: 'Titre',
      },
      sortOrder: {
        desc: 'Décroissant',
        asc: 'Croissant',
      },
      favoritesOnly: 'Favoris uniquement',
      resetFilters: 'Réinitialiser les filtres',
      realtime: 'Temps réel',
      conversationsCount: 'conversation(s)',
      agent: 'Agent',
      messages: 'message(s)',
      sources: {
        whatsapp: 'WhatsApp',
        widgetExternal: 'Widget externe',
        widgetInternal: 'Widget interne',
      },
      humanTakeover: {
        human: 'Humain',
        auto: 'Auto',
        takeover: 'Prendre le contrôle',
        release: 'Relâcher le contrôle',
        takeoverTitle: 'Prendre le contrôle (désactiver l\'agent)',
        releaseTitle: 'Relâcher le contrôle (réactiver l\'agent)',
      },
      favorite: {
        add: 'Ajouter aux favoris',
        remove: 'Retirer des favoris',
      },
      delete: {
        title: 'Supprimer la conversation',
        confirm: 'Êtes-vous sûr de vouloir supprimer cette conversation ?',
        error: 'Erreur lors de la suppression',
      },
      resume: {
        title: 'Reprendre dans le chat',
        success: 'Conversation chargée ! Ouvrez le ChatWidget pour continuer.',
      },
      toast: {
        newMessage: 'Nouveau message',
        takeoverActivated: 'Takeover activé',
        agentReactivated: 'Agent réactivé',
        autoTakeover: 'Auto-takeover détecté',
      },
      time: {
        justNow: 'à l\'instant',
        minutesAgo: 'il y a {n} min',
        hoursAgo: 'il y a {n}h',
        daysAgo: 'il y a {n}j',
      },
    },
    memory: {
      title: 'Mémoire',
      tagline: 'Gérez la mémoire perpétuelle de vos agents',
      tabs: {
        facts: 'Faits',
        scopes: 'Scopes',
        categories: 'Catégories',
      },
      filters: {
        search: 'Recherche',
        searchPlaceholder: 'Rechercher un fait...',
        scope: 'Scope',
        allScopes: 'Tous les scopes',
        category: 'Catégorie',
        allCategories: 'Toutes les catégories',
      },
      buttons: {
        newFact: 'Nouveau fait',
        newScope: 'Nouveau scope',
      },
      empty: {
        facts: 'Aucun fait trouvé. Créez votre premier fait mémoire.',
      },
      badges: {
        verified: 'Vérifié',
        redacted: 'Masqué',
        system: 'Système',
        business: 'Business',
        endUser: 'End-User',
      },
      labels: {
        scope: 'Scope',
        source: 'Source',
        used: 'Utilisé',
        times: 'fois',
        facts: 'faits',
        ttl: 'TTL',
        days: 'jours',
        permanent: 'Permanent',
      },
      tooltips: {
        edit: 'Modifier',
        delete: 'Supprimer',
      },
      confirm: {
        deleteScope: 'Supprimer ce scope ? Tous les faits associés seront supprimés.',
        deleteFact: 'Supprimer ce fait ?',
      },
      errors: {
        delete: 'Erreur lors de la suppression',
        loadData: 'Erreur lors du chargement des données',
        loadFacts: 'Erreur lors du chargement des faits',
      },
    },
    endUsers: {
      title: 'End-Users (Clients)',
      tagline: 'Gérez vos clients identifiés et leur mémoire personnalisée',
      searchPlaceholder: 'Rechercher par nom, email, ID externe...',
      search: 'Rechercher',
      newClient: 'Nouveau client',
      stats: {
        totalClients: 'Total Clients',
        active7d: 'Actifs (7j)',
        withEmail: 'Avec Email',
      },
      empty: {
        noResults: 'Aucun client trouvé.',
        noClients: 'Aucun client enregistré. Les clients seront créés automatiquement lors de leur première identification.',
      },
      labels: {
        id: 'ID',
        username: 'Nom d\'utilisateur',
        created: 'Créé',
        seen: 'Vu',
        never: 'Jamais',
      },
      tooltips: {
        stats: 'Statistiques',
        export: 'Export RGPD',
        anonymize: 'Anonymiser',
        delete: 'Supprimer',
      },
      confirm: {
        delete: 'Supprimer {name} ?',
        deleteWarning: 'Toutes les données mémoire associées seront supprimées (RGPD).',
        anonymize: 'Anonymiser {name} ?',
        anonymizeWarning: 'Les données personnelles seront supprimées mais les statistiques conservées.',
      },
      errors: {
        loadStats: 'Erreur lors du chargement des statistiques',
        export: 'Erreur lors de l\'export',
        delete: 'Erreur lors de la suppression',
        anonymize: 'Erreur lors de l\'anonymisation',
      },
      modal: {
        statsTitle: 'Statistiques',
        memoryScopes: 'Scopes Mémoire',
        memoryFacts: 'Faits Mémoire',
        externalId: 'ID Externe',
        email: 'Email',
        createdAt: 'Créé le',
        lastActivity: 'Dernière activité',
        close: 'Fermer',
        newClientTitle: 'Nouveau Client',
        newClientInfo: 'Les clients sont créés automatiquement lors de leur première identification via WordPress ou JWT.',
        newClientApi: 'Vous pouvez aussi les créer manuellement via l\'API',
      },
    },
    email: {
      title: 'Email',
      tagline: 'Gérez vos connexions email et les réponses automatiques par agent IA',
      observeTitle: 'Suivre les réponses automatiques',
      observeBody:
        'Ouvrez « Messages » sur la connexion : le statut « Répondu » confirme l’envoi (SendGrid), « Échec » affiche l’erreur, « En attente » une réponse générée non envoyée. Les compteurs sur chaque carte reflètent ce que Totemium a traité. « Dernière vérif. » = dernier passage du polling (emails non lus IMAP). En cas de blocage, un message d’erreur apparaît aussi sur la carte.',
      messagesModalHint:
        'Statut « Répondu » = réponse envoyée. « Échec » = ouvrir le détail (ex. domaine SendGrid).',
      detailReplySentAt: 'Réponse envoyée le',
      refresh: 'Actualiser',
      newConnection: 'Nouvelle connexion',
      connections: 'Vos connexions email',
      noConnections: 'Aucune connexion pour le moment',
      connectionsCount: 'connexion(s) configurée(s)',
      delete: {
        title: 'Supprimer la connexion',
        irreversible: 'Cette action est irréversible.',
        close: 'Fermer',
        confirm: 'Êtes-vous sûr de vouloir supprimer la connexion',
        warning: 'Tous les messages et patterns associés seront supprimés.',
        cancel: 'Annuler',
        deleting: 'Suppression…',
        deletePermanently: 'Supprimer définitivement',
      },
      card: {
        processed: 'Traités',
        interval: 'Intervalle',
        lastCheck: 'Dernière vérif',
        totemiumActivity: 'Activité dans Totemium',
        statReceivedShort: 'reçus',
        statRepliedShort: 'répondus',
        statPendingShort: 'en attente',
        enabled: '✓ Activé',
        disabled: 'Désactivé',
        auto: '🤖 Auto',
        manual: 'Manuel',
        messages: 'Messages',
        patterns: 'Patterns',
        settings: 'Paramètres',
        delete: 'Supprimer',
      },
      empty: {
        title: 'Aucune connexion email',
        description: 'Connectez un compte email IMAP pour permettre à vos agents IA de répondre automatiquement aux emails.',
        addConnection: 'Ajouter une connexion IMAP',
      },
      providers: {
        gmail: 'Gmail',
        outlook: 'Outlook',
        imap: 'IMAP',
      },
      editor: {
        titleNew: 'Nouvelle connexion IMAP',
        titleEdit: 'Modifier',
        cancel: 'Annuler',
        saving: 'Sauvegarde...',
        save: 'Mettre à jour',
        create: 'Créer',
        sectionIdentity: 'Identité',
        emailLabel: 'Adresse email *',
        displayNameLabel: 'Nom d\'affichage',
        displayNamePlaceholder: 'Support Client',
        agentLabel: 'Agent IA',
        agentNone: 'Aucun agent',
        agentHelp: 'L\'agent générera les réponses automatiques aux emails',
        sectionImap: 'Serveur IMAP',
        imapHostLabel: 'Hôte IMAP *',
        imapHostPlaceholder: 'imap.votredomaine.com',
        smtpHostLabel: 'Hôte SMTP',
        smtpHostPlaceholder: 'smtp.votredomaine.com',
        portLabel: 'Port',
        useTls: 'Utiliser TLS/SSL',
        testReenterCredentials: 'Pour tester la connexion, veuillez re-saisir vos identifiants ci-dessous',
        testBtn: 'Tester la connexion',
        testing: 'Test en cours...',
        sectionAuth: 'Authentification',
        usernameLabel: 'Nom d\'utilisateur',
        usernamePlaceholder: 'contact@votredomaine.com',
        usernameUnchanged: '(inchangé)',
        keepCurrentHint: 'Laissez vide pour conserver l\'actuel',
        passwordLabel: 'Mot de passe',
        sectionSettings: 'Paramètres',
        checkIntervalLabel: 'Intervalle de vérification (minutes)',
        enabledLabel: 'Connexion activée',
        autoReplyLabel: 'Réponse automatique IA',
        sectionDomain: 'Vérification de domaine',
        infoTitle: '💡 Configuration IMAP',
        infoPort993: 'Port IMAP standard avec TLS:',
        infoPort587: 'Port SMTP standard avec STARTTLS:',
        infoGmail: 'Pour Gmail, utilisez un',
        infoGmailAppPassword: 'mot de passe d\'application',
        infoImap: 'Vérifiez que l\'accès IMAP est activé dans les paramètres de votre fournisseur email',
        errorEmailRequired: 'L\'adresse email est requise',
        errorImapRequired: 'Le serveur IMAP est requis',
        errorUsernameRequired: 'Le nom d\'utilisateur est requis',
        errorPasswordRequired: 'Le mot de passe est requis',
      },
    },
    workflows: {
      title: 'Workflows',
      tagline: 'Automatisez des tâches pour vos agents avec des déclencheurs et des actions',
      newWorkflow: 'Nouveau workflow',
      createWorkflow: 'Créer un workflow',
      searchPlaceholder: 'Rechercher un workflow...',
      allAgents: 'Tous les agents',
      allStatuses: 'Tous les statuts',
      active: 'Actifs',
      inactive: 'Inactifs',
      delete: {
        title: 'Supprimer le workflow',
        irreversible: 'Cette action est irréversible.',
        close: 'Fermer',
        confirm: 'Êtes-vous sûr de vouloir supprimer',
        cancel: 'Annuler',
        delete: 'Supprimer',
      },
      errors: {
        load: 'Erreur lors du chargement',
        toggle: 'Erreur lors de la modification',
        delete: 'Erreur lors de la suppression',
      },
      stats: {
        activeWorkflows: 'Workflows actifs',
        activeDescription: 'Workflows en cours d\'exécution',
        executionsToday: 'Exécutions aujourd\'hui',
        executionsDescription: 'Tâches automatisées ce jour',
        successRate: 'Taux de succès',
        successDescription: 'Sur les dernières 24h',
        totalWorkflows: 'Total workflows',
        totalDescription: 'Tous les workflows créés',
      },
      empty: {
        title: 'Aucun workflow',
        noResults: 'Aucun workflow ne correspond à vos critères',
        createFirst: 'Créez votre premier workflow pour automatiser vos agents',
      },
      card: {
        agent: 'Agent',
        executions: 'Exécutions',
        success: 'Succès',
        failures: 'Échecs',
        nextRun: 'Prochaine exécution',
        view: 'Voir',
        edit: 'Modifier',
        delete: 'Supprimer',
        enable: 'Activer',
        disable: 'Désactiver',
      },
      connectors: {
        schedule: 'Planification',
        manual: 'Manuel',
        webhook: 'Webhook',
        email: 'Email',
        email_imap: 'Email IMAP',
        rss_feed: 'Flux RSS',
        slack: 'Slack',
        webhook_out: 'Webhook sortant',
        unknown: 'Inconnu',
      },
    },
  },
  en: {
    sidebar: {
      menu: 'Menu',
      system: 'System',
      sectionOverview: 'Overview',
      sectionKnowledges: 'Knowledge',
      sectionAgentsDiscussions: 'Agents & Messenger',
      sectionAdvanced: 'Advanced',
      advancedMore: 'More',
      advancedLess: 'Less',
      badgePreview: 'Preview',
      badgeBeta: 'Beta',
      sharedApiKeys: 'Shared API keys',
      dashboard: 'Dashboard',
      knowledges: 'Knowledge bases',
      agents: 'AI agents',
      memory: 'Agent memory',
      endUsers: 'End users',
      conversations: 'Conversations',
      email: 'Email',
      workflows: 'Automation',
      messenger: 'Messenger',
      agencyDashboard: 'Agency workspace',
      admin: 'Admin',
      configuration: 'Settings',
      myAccount: 'My account',
      logout: 'Log out',
      openMenu: 'Open menu',
      closeMenu: 'Collapse menu',
    },
    header: {
      profile: 'Profile',
      connected: 'Connected',
      startGuide: 'Getting Started Guide',
      documentation: 'Documentation',
      contactUs: 'Contact Us',
      myAccount: 'My Account',
      logout: 'Log out',
    },
    pageTitles: {
      dashboard: 'Dashboard',
      conversations: 'Conversations',
      conversationHistory: 'History',
      agents: 'AI Agents',
      knowledges: 'Knowledge Base',
      library: 'Library',
      catalog: 'Catalog',
      administration: 'Administration',
      widgetConfig: 'Widget Configuration',
      branding: 'Branding',
      sendgrid: 'SendGrid Notifications',
      publicAgent: 'Public Agent',
      systemPrompts: 'System Prompts',
      paymentStripe: 'Stripe Payment',
      ollamaCloud: 'Ollama Cloud',
      configuration: 'Configuration',
      wordpress: 'WordPress',
      openai: 'OpenAI',
      anthropic: 'Anthropic',
      sendgridAgent: 'SendGrid (agent email replies)',
      users: 'Users',
      models: 'Models',
      integrations: 'Integrations',
      mcp: 'MCP',
      monitoring: 'Monitoring',
      logs: 'Logs',
      logsMcp: 'MCP Logs',
      profile: 'Profile',
      twoFA: '2FA Authentication',
      workflows: 'Workflows',
      planManagement: 'Plan Management',
      adminUsers: 'Admin Users',
      adminAffiliate: 'Affiliate program',
      pricing: 'Pricing',
      myAccountPage: 'My Account',
      memory: 'Memory',
      endUsers: 'End-Users',
      email: 'Email',
    },
    affiliate: {
      navLabel: 'Referrals',
      title: 'Referral program',
      subtitle: 'Share Totemium and earn commission on eligible subscriptions.',
      yourCode: 'Your code',
      yourLink: 'Share link',
      copy: 'Copy',
      copied: 'Copied',
      referrals: 'Referrals',
      payable: 'Pending payout',
      paid: 'Already paid out',
      connectNote: 'Payout',
      commissionsTitle: 'Commission history',
      emptyCommissions: 'No commissions yet.',
      plan: 'Plan',
      amount: 'Amount',
      docsLink: 'Program terms',
      recurringOn: 'Commission on each renewal',
      recurringOff: 'Commission on the referred user’s first payment only',
      contractTitle: 'Affiliate agreement',
      contractSubtitle:
        'Most SaaS affiliate programs require explicit acceptance before you can promote the product. Read the text below, then confirm.',
      contractVersionLabel: 'Agreement version',
      contractAcceptCheckbox:
        'I have read and accept this agreement and the affiliate program rules.',
      contractAcceptButton: 'Accept and continue',
      contractEmpty: '_No agreement text configured by the administrator._',
      holdPeriodNote:
        'Payout hold: {days} days after the referred user’s enrollment (attribution date).',
      linkHiddenUntilContract: 'Accept the agreement above to reveal your code and link.',
      pendingHold: 'On hold (waiting period)',
      pendingHoldHint: 'Amount still inside the post-enrollment waiting period.',
      payableAt: 'Payable from',
      dashboardPrivacyNote:
        'Privacy: you only see an internal technical ID for each referred user; real identity is handled by Totemium.',
      referralsSectionTitle: 'My referrals',
      referredUserIdColumn: 'Referred user ID',
      referredUserIdTooltip:
        'Internal Totemium ID for the referred user (non-identifying). Support can map this ID to an account if needed.',
      referredUserIdHint:
        'Referrals are listed with internal IDs only, in line with our privacy policy.',
      attributedAt: 'Attribution date',
      source: 'Source',
      commissionsCount: 'Commissions',
      totalCommissionCents: 'Total commission',
      lastCommissionAt: 'Last commission',
      hasPaidBadge: 'Paid out',
      emptyReferrals: 'No referred users yet.',
      exportReferralsCsv: 'Export CSV',
      chartTitle: 'Commissions by month',
      chartEmpty: 'No monthly series yet (no recorded commissions).',
      statsAttributedLabel: 'Attributions (total)',
      statsWithCommissionLabel: 'Referred users with at least one commission',
      linkViewsSectionTitle: 'Referral link views',
      linkViewsHint:
        'A view is recorded on the first open of your ?ref= link per browser session. Referrer site and UTM parameters are stored when the browser sends them.',
      linkViewsTotal: 'Link views (all time)',
      linkViewsLast30: 'Views (last 30 days)',
      linkViewsChartTitle: 'Views by month',
      linkViewsShort: 'Views',
      topReferrersTitle: 'Traffic sources (referrers)',
      columnReferrerDomain: 'Source',
      columnViewCount: 'Views',
    },
    modelsPlatformAdmin: {
      pageTitle: 'LLM models (platform)',
      pageSubtitle:
        'Ollama: pull models on the server. For each provider, enable models offered to tenants (global filter, then workspace catalog). By default, OpenAI and Anthropic are all off until you turn switches on.',
      tabOllama: 'Ollama',
      tabOpenai: 'OpenAI',
      tabAnthropic: 'Anthropic',
      save: 'Save selection',
      saving: 'Saving…',
      loadError: 'Could not load platform catalog',
      saveError: 'Could not save',
      tenantSwitch: 'Offered to tenants',
      sortLabel: 'Order',
      pullTitle: 'Pull a model',
      pullPlaceholder: 'e.g. llama3.2:3b',
      pullButton: 'Pull (stream)',
      pulling: 'Downloading…',
      pullStorageHint: 'Stored on the Ollama server (e.g. /var/lib/totemai/ollama/).',
      backAdmin: 'Back to admin',
      colName: 'Name',
      colSize: 'Size',
      colModified: 'Modified',
      colDigest: 'Digest',
      colActions: 'Actions',
      defaultBadge: 'Default',
      setDefault: 'Set default',
      currentDefault: 'Current default model: {name}',
      deleting: 'Deleting…',
      delete: 'Delete',
      noModels: 'No local models.',
      loading: 'Loading…',
    },
    adminAffiliate: {
      title: 'Affiliate program',
      subtitle: 'Database settings, referrers, attributions, commissions, and Stripe Connect.',
      tabSettings: 'Settings',
      tabReferrers: 'Referrers',
      tabAttributions: 'Attributions',
      tabCommissions: 'Commissions',
      programEnabled: 'Program enabled',
      commissionRateBps: 'Rate (basis points, e.g. 1500 = 15%)',
      recurringCommissions: 'Commission on each renewal',
      maxCommissionMonths: 'Commission window (months, 0 = unlimited)',
      minInvoiceCents: 'Minimum invoice amount (cents)',
      payableAfterReferralDays: 'Hold before payable (days after referred user enrollment)',
      payableAfterReferralHint:
        '0 = payable as soon as the invoice qualifies. E.g. 60 = commissions stay pending until 60 days after attribution (first-touch). Common to mitigate refunds/chargebacks.',
      contractSection: 'Affiliate agreement (required if text is set)',
      contractVersion: 'Agreement version (bump to require re-acceptance)',
      contractVersionHint: 'SaaS practice: new version = all affiliates must accept again.',
      contractMarkdown: 'Agreement body (Markdown)',
      contractMarkdownPlaceholder:
        'Replace {{PLACEHOLDERS}}; a draft loads when this field was empty.',
      pendingHoldStatus: 'On hold (pending_hold)',
      payableAt: 'Payable from',
      excludedPlanSlugs: 'Excluded plan slugs (comma-separated)',
      cookieName: 'Referral cookie name',
      cookieMaxAge: 'Cookie max-age (seconds, min 60)',
      stripeConnectPayouts: 'Automatic payouts via Stripe Connect (Transfer)',
      stripeConnectCountry: 'Default Express account country (ISO2)',
      defaultPayoutCurrency: 'Ledger currency (ISO3)',
      emailSearch: 'Filter by email',
      emailColumn: 'Email',
      publicCode: 'Code',
      referralsCount: 'Referrals',
      payableCents: 'Payable (¢)',
      paidCents: 'Paid (¢)',
      suspend: 'Suspend',
      activate: 'Activate',
      rotateCode: 'New code',
      stripeOnboarding: 'Stripe onboarding',
      total: 'Total',
      prev: 'Previous',
      next: 'Next',
      createAttribution: 'Create attribution',
      attributionsCreateTitle: 'New attribution',
      attributionsCreateHint:
        'Manually link a referrer to a referred user. Enter ID or email for each side (at least one per person).',
      attributionsCreateNeedBoth:
        'Provide an identifier (ID or email) for both referrer and referred user.',
      attributionsFilterTitle: 'Filter list',
      attributionsFilterHint:
        'Filter by ID and/or email; leave empty for all. ID and email for the same role must match the same account.',
      attributionsResetFilters: 'Clear filters',
      attributionsListTitle: 'Saved attributions',
      newReferrerId: 'Referrer user ID',
      newReferredId: 'Referred user ID',
      newReferrerEmail: 'Referrer email',
      newReferredEmail: 'Referred user email',
      filterReferrerId: 'Filter referrer ID',
      filterReferredId: 'Filter referred user ID',
      filterReferrerEmail: 'Filter referrer email',
      filterReferredEmail: 'Filter referred email',
      suspended: 'Suspended',
      stripeTransfer: 'Stripe transfer',
      markPaidStripe: 'Stripe payout',
      filterStatus: 'Status',
      allStatuses: 'All',
      payableOnly: 'Payable only',
      exportCsv: 'Export CSV',
      refresh: 'Refresh',
      markPaid: 'Mark paid',
      payoutRef: 'Payout reference',
      payoutRefPlaceholder: 'e.g. wire transfer 2026-04-05',
      referrer: 'Referrer',
      referred: 'Referred',
      invoice: 'Stripe invoice',
    },
    footer: {
      rights: 'All rights reserved.',
    },
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      loading: 'Loading...',
      noResults: 'No results',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      close: 'Close',
      yes: 'Yes',
      no: 'No',
      actions: 'Actions',
      status: 'Status',
      name: 'Name',
      description: 'Description',
      date: 'Date',
      type: 'Type',
      active: 'Active',
      inactive: 'Inactive',
      enabled: 'Enabled',
      disabled: 'Disabled',
      selectLanguage: 'Select language',
      irreversibleAction: 'This action is irreversible.',
      confirmDeletePrefix: 'Are you sure you want to delete',
      errorWhileDeleting: 'Error while deleting',
      deleteInProgress: 'Deleting...',
      deletePermanently: 'Delete permanently',
    },

    dashboard: {
      loadStatsError: 'Error loading stats',

      cards: {
        indexedMediaTitle: 'Indexed media',
        indexedMediaDescription: 'Total number of processed files',
        embeddingsTitle: 'Embeddings',
        embeddingsDescription: 'Vectors available for RAG',
        trackedStatusesTitle: 'Tracked statuses',
        trackedStatusesDescription: 'Active processing states',
        linkedCoursesTitle: 'Linked courses',
        linkedCoursesDescription: 'Connected courses or learning paths',
      },

      recent: {
        title: 'Latest ingested media',
        description: 'Last processed contents. Track their status and related course.',
        table: {
          title: 'Title',
          status: 'Status',
          course: 'Course',
          date: 'Date',
        },
        empty: 'No media available at the moment.',
      },

      activity: {
        title: 'Last 7 days activity',
        totalDescription: 'Total media processed over the last seven days.',
      },

      statuses: {
        title: 'Active statuses',
        empty: 'No tracked status.',
      },
    },

    agencyDashboard: {
      title: 'Agency Dashboard',
      subtitle: 'Global view of all your workspaces',
      loading: 'Loading...',
      error: 'Error loading data',
      notAgency: 'This page is reserved for Agency plan users',
      upgradeButton: 'Upgrade to Agency plan',
      pooledQuotas: 'Pooled quotas',
      pooledQuotasDescription: 'Your quotas (agents, conversations, storage) are shared across all your workspaces. The total displayed represents the global usage of your Agency account.',
      unlimited: 'Unlimited',
      thisMonth: 'this month',
      items: 'items',
      workspace: 'workspace',
      workspaces: 'workspaces',
      plan: 'Plan',
      preview: 'Preview',
      production: 'Production',
      
      globalMetrics: {
        title: 'Global metrics',
        agents: 'Agents',
        storage: 'Storage',
        workspaces: 'Workspaces',
        conversations: 'Conversations',
        knowledge: 'Knowledge',
        of: 'of',
      },

      workspacesList: {
        title: 'Your workspaces',
        name: 'Name',
        agents: 'Agents',
        storage: 'Storage',
        conversations: 'Conversations',
        knowledgeItems: 'Knowledge',
        createdAt: 'Created on',
        mode: 'Mode',
        preview: 'Preview',
        production: 'Production',
      },
    },

    knowledges: {
      tagline: 'Manage your collections and contents to enrich your AI assistants',
      collections: 'Collections',
      stats: 'Statistics',
      syncs: 'Syncs',

      panel: {
        orphanTitle: 'Contents without a collection',
        contentsOfPrefix: 'Contents of',
        allContents: 'All contents',
        contentCount: 'content',
      },

      collectionsSidebar: {
        allContents: 'All contents',
        withoutCollection: 'Without a collection',
        newCollection: 'New collection',
        manual: 'Manual',
        wordpress: 'WordPress',
        deleteCollectionTitle: 'Delete collection',
        deleteCollectionWarning: 'Associated contents will not be deleted but will become orphaned.',
      },

      collectionCreate: {
        title: 'New collection',
        subtitle: 'Create a grouping to organize your contents',
        collectionTitleLabel: 'Collection title',
        placeholder: 'e.g. Onboarding training',
        titleRequired: 'Title is required',
        creationError: 'Error while creating',
        creating: 'Creating...',
        create: 'Create collection',
        tipsTitle: 'Tips',
        tip1: 'Group by topic or training for clarity.',
        tip2: 'WordPress collections are synced automatically.',
        tip3: 'You will be able to rename or delete this collection later.',
        kbLanguageLabel: 'Content language (RAG retrieval)',
        kbLanguageHint: 'Tell us which language your documents are written in; the assistant can still reply in the user\'s language.',
      },

      kbContentLanguage: {
        label: 'Document language',
        hint: 'Improves RAG relevance. Leave unset to use the platform default.',
        autoOption: 'Automatic / unset',
        langFr: 'French (fr)',
        langEn: 'English (en)',
        langEs: 'Spanish (es)',
        langDe: 'German (de)',
        langIt: 'Italian (it)',
        langPt: 'Portuguese (pt)',
        langNl: 'Dutch (nl)',
        langZhHans: 'Simplified Chinese (zh-hans)',
        sidebarTitle: 'KB',
      },

      contentsPanel: {
        allStatuses: 'All statuses',
        indexed: 'Indexed',
        transcribed: 'Transcribed',
        pending: 'Pending',
        transcribing: 'Transcribing...',
        indexing: 'Indexing...',
        inError: 'Error',
        addContentShort: '+ Content',
        emptyTitle: 'No content',
        emptyOrphan: 'All your contents are associated with a collection.',
        emptyDefault: 'Add your first content to enrich this collection.',
        addFirstContent: '+ Add content',
        deleteContentTitle: 'Delete content',
        deleteContentWarning: 'Transcripts, embeddings and metadata will be permanently deleted.',
      },

      contentCard: {
        indexedAtPrefix: 'Indexed',
        viewDetails: 'View details',
        reindexClassic: 'Re-index (classic chunking)',
        alreadyLLMSegmented: 'Already AI-segmented',
        llmSegmentation: 'AI segmentation (better RAG quality)',
        forceTranscribe: 'Force transcription',
        yesterday: 'yesterday',
        justNow: 'just now',
        minutesAgo: '{n} min ago',
        hoursAgo: '{n}h ago',
        daysAgo: '{n}d ago',
      },

      contentDetail: {
        titleFallback: 'Content details',
        cannotLoadDetails: 'Unable to load details',
        collection: 'Collection',
        withoutCollection: 'No collection',
        move: 'Move',
        currentlyInPrefix: 'Currently in:',
        categories: 'Categories',
        course: 'Course',
        chunks: 'Chunks',
        embeddings: 'Embeddings',
        file: 'File',
        size: 'Size',
        mb: 'MB',
        embeddingsByCategory: 'Embeddings by category',
        transcription: 'Transcript',
        characters: 'characters',
        language: 'Language',
        noTranscription: '— No transcript available —',
        transcriptionUnavailable: 'Transcript unavailable',
        downloadTranscription: 'Download transcript',
        downloadTxt: 'Download .txt',
        reindex: 'Re-index',
        llmSegmentation: 'AI segmentation',
        forceTranscribe: 'Force transcription',
      },

      statsDrawer: {
        title: 'Statistics',
        subtitle: 'Overview of your knowledge base',
        collections: 'Collections',
        contents: 'Contents',
        total: 'Total',
        manuals: 'Manual',
        wordpress: 'WordPress',
        orphanContents: 'Orphaned contents',
        ready: 'Ready',
        indexed: 'Indexed',
        transcribed: 'Transcribed',
        processing: 'Processing',
        pending: 'Pending',
        errors: 'Errors',
        globalHealth: 'Overall health',
        usableContents: 'Usable contents',
        healthHint: '{ready} contents out of {total} are ready to be used by your agents.',
        byStatus: 'Breakdown by status',
      },

      wpImport: {
        title: 'Import from WordPress',
        chooseContentType: 'Choose content type',
        selectContentsPrefix: 'Select',
        confirmImport: 'Confirm import',
        importing: 'Importing...',
        completed: 'Import completed',
        error: 'Error',
        availableQuota: 'Available quota',
        credits: 'credits',
        selected: 'selected',
        continue: 'Continue →',
        quotaEnough: '✓ Quota is enough',
        quotaNotEnough: '✗ Quota not enough ({n} items over)',
        back: 'Back',
        launching: 'Launching...',
        importN: 'Import {n} content{s}',
        editSelection: 'Edit selection',
        importSummary: 'Import summary',
        selectedContents: 'Selected contents',
        totalChars: 'Total characters',
        requiredCredits: 'Required credits',
        creditsAfter: 'Credits after import',
        quotaAfter: 'Quota after import',
        importPossible: '✅ Import possible',
        quotaExceeded: '⚠️ Quota exceeded by {n} credits',
        importOptions: 'Import options',
        destinationCollection: 'Destination collection',
        autoCreate: 'Auto-create',
        autoCreateFromCourses: 'Create collections from WordPress courses',
        items: 'items',
        item: 'item',
        notAvailable: '(not available)',
        selectAll: 'Select all',
        none: 'None',
        availableSuffix: 'available',
        noTitle: '(Untitled)',
        modified: 'Modified',
        imported: 'Imported',
        charCount: '{n} characters',
        approxChars: '~ characters',
        loadMore: 'Load more',
        cancelImport: 'Cancel import',
        importWithErrors: 'Import completed with errors',
        importDone: 'Import completed!',
        importedSuccess: '{n} content{s} imported successfully',
        success: 'Success',
        failed: 'Failed',
      },
      upload: {
        title: 'Add Content',
        description: 'Import a new media: it will be automatically transcribed and indexed.',
        close: 'Close',
        collection: 'Collection',
        course: 'WordPress Course (optional)',
        choose: '— choose —',
        advice: 'Recommended: attach your content to a collection to optimize RAG.',
        courseHelp: 'If no collection is selected, attach the media to a WordPress course.',
        dropzoneTitle: 'Drag and drop your files here, or click to browse.',
        formats: 'Accepted formats: mp3, wav, mp4, mov, txt, md, pdf.',
        filesSelected: '{n} file(s) selected',
        uploading: 'Upload in progress…',
        completed: 'Upload completed',
        upload: 'Upload',
        reset: 'Reset',
        footer: 'Uploaded content will appear in the library after indexing. Monitor their status from the contents page.',
        errorLoadSubjects: 'Error loading subjects',
        errorSelectFile: 'Select at least one file',
        success: '{n} file(s) uploaded successfully',
        partialSuccess: '{success} successful, {error} failed',
        mb: 'MB',
      },
    },
    agents: {
      title: 'Your agents',
      tagline: 'Manage your AI agents and their configuration',
      statsDrawerTitle: 'Agent dashboard',
      statsDrawerSubtitle: 'Track your quotas and most active agents.',
      createAgent: 'Create new agent',
      statistics: 'Statistics',
      loading: 'Loading agents…',
      noAgents: 'No agents yet. Create your first assistant by defining its personality, icon and knowledge bases.',
      lastUpdated: 'Last updated',
      quotaBadge: {
        active: 'active',
        max: 'max',
        quotaReached: 'Quota reached',
      },
      deleteModal: {
        title: 'Delete agent',
        warning: 'This action permanently removes the agent and its statistics.',
        linkedSubjectsWarning: 'The agent is linked to {n} subject(s). Media will remain accessible but the agent will no longer be able to respond to conversations.',
        noSubjectsWarning: 'The agent will be immediately removed from your integrations (chat widget, API, etc.).',
      },
      agentCard: {
        active: 'Active',
        inactive: 'Inactive',
        messages: 'Messages',
        docs: 'Docs',
        ai: 'AI',
        updated: 'Updated',
        useInChat: 'Use in chat',
        history: 'History',
        edit: 'Edit',
        deactivate: 'Deactivate',
        activate: 'Activate',
        mcp: 'MCP',
        assignEmail: 'Assign email',
        changeIcon: 'Change icon',
        uploading: 'Upload…',
        delete: 'Delete',
        deleting: 'Deleting…',
      },
      stats: {
        activeAgents: 'Active agents',
        activeAgentsDesc: 'Agents ready to respond in chat',
        activeAgentsEmpty: 'Create your first custom agent',
        messagesSent: 'Messages sent',
        messagesRemaining: '{n} messages remaining',
        noLimit: 'No limit defined',
        globalQuota: 'Global quota',
        limitLabel: 'Owner limit',
        unlimitedPlan: 'Unlimited plan',
        lastUpdate: 'Last update',
        noAgentYet: 'No agent yet',
        recentAgent: 'Most recent agent',
        usageGlobal: 'Global usage',
        messagesOrg: 'messages sent by the organization',
        totalAgents: 'Total agents',
        knowledgeBases: 'Knowledge bases',
        aiUsed: 'AI models used',
        totalMessagesByAgents: 'Total messages by agents',
        globalQuotaTitle: 'Global quota',
        messagesAllowed: 'messages allowed',
        utilization: 'Utilization',
        unlimited: 'Unlimited',
        remainingMessages: '{n} messages remaining for the period.',
        lastAgentCreated: 'Last agent created',
        mostActiveAgents: 'Most active agents',
        top5Period: 'Top 5 for the current period',
        noMessagesYet: 'No messages sent yet.',
        maxLabel: 'max',
        noCap: 'No cap',
        docsSuffix: 'doc(s)',
        messagesSuffix: 'messages',
      },
      sandbox: {
        title: 'Agent sandbox',
        subtitle: 'Configure the agent and test it in the playground.',
        quotaPreserved: 'Quota preserved',
        settings: 'Settings',
        playgroundTitle: 'Playground sandbox',
        playgroundSubtitle: 'Ask questions in sandbox mode without consuming quota.',
        close: 'Close',
        save: 'Save',
        saving: 'Saving…',
      },
      errors: {
        loadAgents: 'Error loading agents',
        createAgent: 'Error creating agent',
        updateAgent: 'Error updating agent',
        deleteAgent: 'Deletion failed',
        toggleActivation: 'Error during activation/deactivation',
        quotaReached: 'Active agent quota reached. Deactivate an agent to activate another.',
        uploadIcon: 'Error uploading icon',
      },
      teams: {
        header: 'Teams',
        allAgents: 'All agents',
        noTeam: 'No team',
        newTeam: 'New team',
        deleteTitle: 'Delete team',
        deleteWarning: 'Agents in this team will become orphaned (no team).',
        createModal: {
          title: 'New team',
          subtitle: 'Create a group to organize your agents',
          close: 'Close',
          nameLabel: 'Team name',
          namePlaceholder: 'Ex: Customer support',
          creating: 'Creating...',
          create: 'Create team',
          errorRequired: 'Title is required',
          errorCreate: 'Error creating team',
          tipsTitle: 'Tips',
          tip1: 'Group your agents by function or department.',
          tip2: 'Agents without a team will appear under "No team".',
          tip3: 'You can rename or delete this team later.',
        },
      },
      modelPicker: {
        browse: 'Browse…',
        title: 'Choose a model',
        search: 'Search…',
        tabOllama: 'Ollama',
        tabOpenai: 'OpenAI',
        tabAnthropic: 'Anthropic',
        emptyTab: 'No models',
        noMatch: 'No matches',
        apply: 'Apply',
        cancel: 'Cancel',
        loading: 'Loading…',
      },
      llmCatalog: {
        title: 'Workspace LLM catalog',
        subtitle:
          'Select which models are offered to members. Until at least one active offer exists for a provider, the full list stays visible (default behavior).',
        save: 'Save',
        saving: 'Saving…',
        loadError: 'Could not load catalog',
        saveError: 'Could not save catalog',
        byokNote:
          'OpenAI and Anthropic: a workspace BYOK API key is required to use these models in agents.',
        sortLabel: 'Order',
        enabledLabel: 'Offer',
        colModel: 'Model',
        noKeyBadge: 'No API key',
        workspaceTab: 'LLM models',
        workspaceTabDesc: 'Model offer for members',
        errForbidden: 'You do not have permission to manage this catalog.',
        errPayload: 'Too many entries (limit 500).',
        errUnknownModel: 'An invalid model or provider was sent.',
      },
      agentEditor: {
        titleNew: 'New agent',
        titleEdit: 'Edit',
        cancel: 'Cancel',
        saving: 'Saving...',
        save: 'Update',
        create: 'Create',
        tabGeneral: 'General',
        tabKnowledge: 'Knowledge base',
        tabMemory: '🧠 Memory',
        sectionGeneral: 'General information',
        nameLabel: 'Name',
        namePlaceholder: 'Ex: Support agent',
        subtitleLabel: 'Subtitle',
        subtitlePlaceholder: 'Ex: Totemium support expert',
        iconLabel: 'Icon',
        chooseImage: 'Choose an image',
        instructionsLabel: 'Instructions',
        instructionsPlaceholder: 'Describe the role and behavior of the agent...',
        hideTemplates: '✕ Hide templates',
        changeTemplate: '📚 Change template',
        messageLimitLabel: 'Message limit',
        messageLimitPlaceholder: 'Unlimited',
        messageLimitHelp: 'Max number of messages per conversation',
        sectionAI: 'Artificial intelligence',
        modelLabel: '🧠 AI Model',
        modelDefault: 'Default (system)',
        topKLabel: 'Top K (RAG)',
        topKHelp: 'Default: 10 — Higher = more context but slower',
        rerankLabel: 'Rerank Top N',
        rerankHelp: 'Default: 5 — Number of most relevant documents kept',
        strictLabel: '🎯 Strict responses',
        strictHelp: 'The assistant will ONLY respond with information from your knowledge base',
        sectionTeam: 'Team',
        teamLabel: 'Assign to a team',
        teamNone: 'No team',
        sectionAdminPrompt: '🔧 Admin: System Prompt',
        adminPromptLabel: 'System prompt override',
        adminPromptDefault: 'Default prompt',
        adminPromptHelp: 'Admin only — replaces the global system prompt',
        sectionKnowledge: 'Knowledge base',
        knowledgeHelp: 'Select the documents the agent can consult to answer questions',
        noKnowledge: 'No knowledge base available',
        noKnowledgeHint: 'Create subjects in the Documents section',
        selected: 'Selected',
        sectionMemory: '🧠 Perpetual Memory',
        memoryBusiness: '💼 Business Memory (Tenant)',
        memoryBusinessHelp: 'Enables shared memory for your business knowledge and preferences',
        memoryEndUser: '👤 End-User Memory (Clients)',
        memoryEndUserHelp: 'Memorizes specific information per identified client',
        scopesTitle: '📚 Assigned Scopes',
        noScopes: 'No scope available. Create one on the',
        scopeMemoryLink: 'Memory',
        scopeNoneSelected: '💡 No scope selected - all business scopes will be used',
        scopeSelected: '✓ {n} scope(s) selected',
        memoryPageHint: '💡 Manage your scopes and memory facts on the',
        errorNameRequired: 'Name is required',
        errorSave: 'Error saving',
        agentTypeLabel: '🎭 Agent type',
        agentTypePlaceholder: 'Choose an agent type...',
        templateRecommended: 'Recommended templates',
        templateOthers: 'Other templates',
        templateCount: '{n} template{s} available',
        templateNoAvailable: 'No template available for this agent type',
        templateTipTitle: 'Tip',
        templateTipBody: 'You can use a template as a base and customize it in the Instructions field. Templates are optimized for each agent type.',
        levelBasic: 'Basic',
        levelAdvanced: 'Advanced',
        levelPremium: 'Premium',
        badgeRecommended: 'Recommended',
        badgeUsed: 'Used',
        btnPreview: 'Preview',
        btnHide: 'Hide',
        btnUse: 'Use',
        labelPopularity: 'Popularity',
      },
    },
    conversations: {
      title: 'Conversations',
      historyForAgent: 'History · {name}',
      backToAgents: 'Agents',
      loading: 'Loading conversations...',
      errorLoading: 'Error loading conversations',
      noConversations: 'No conversations',
      searchPlaceholder: 'Search...',
      filters: 'Filters',
      hideFilters: 'Hide',
      allSources: 'All',
      whatsApp: 'WhatsApp',
      widgetExt: 'Widget Ext',
      widgetInt: 'Widget Int',
      filteredBy: 'Filtered by:',
      allAgents: 'All agents',
      allUsers: 'All users',
      allPeriods: 'All periods',
      today: 'Today',
      thisWeek: 'This week',
      thisMonth: 'This month',
      allMessages: 'All messages',
      short: 'Short (1-3 msg)',
      medium: 'Medium (4-10 msg)',
      long: 'Long (10+ msg)',
      sortBy: {
        updatedAt: 'Last activity',
        createdAt: 'Creation date',
        title: 'Title',
      },
      sortOrder: {
        desc: 'Descending',
        asc: 'Ascending',
      },
      favoritesOnly: 'Favorites only',
      resetFilters: 'Reset filters',
      realtime: 'Realtime',
      conversationsCount: 'conversation(s)',
      agent: 'Agent',
      messages: 'message(s)',
      sources: {
        whatsapp: 'WhatsApp',
        widgetExternal: 'External widget',
        widgetInternal: 'Internal widget',
      },
      humanTakeover: {
        human: 'Human',
        auto: 'Auto',
        takeover: 'Take over',
        release: 'Release control',
        takeoverTitle: 'Take control (disable agent)',
        releaseTitle: 'Release control (re-enable agent)',
      },
      favorite: {
        add: 'Add to favorites',
        remove: 'Remove from favorites',
      },
      delete: {
        title: 'Delete conversation',
        confirm: 'Are you sure you want to delete this conversation?',
        error: 'Error while deleting',
      },
      resume: {
        title: 'Resume in chat',
        success: 'Conversation loaded! Open the ChatWidget to continue.',
      },
      toast: {
        newMessage: 'New message',
        takeoverActivated: 'Takeover activated',
        agentReactivated: 'Agent reactivated',
        autoTakeover: 'Auto-takeover detected',
      },
      time: {
        justNow: 'just now',
        minutesAgo: '{n} min ago',
        hoursAgo: '{n}h ago',
        daysAgo: '{n}d ago',
      },
    },
    memory: {
      title: 'Memory',
      tagline: 'Manage your agents perpetual memory',
      tabs: {
        facts: 'Facts',
        scopes: 'Scopes',
        categories: 'Categories',
      },
      filters: {
        search: 'Search',
        searchPlaceholder: 'Search for a fact...',
        scope: 'Scope',
        allScopes: 'All scopes',
        category: 'Category',
        allCategories: 'All categories',
      },
      buttons: {
        newFact: 'New fact',
        newScope: 'New scope',
      },
      empty: {
        facts: 'No facts found. Create your first memory fact.',
      },
      badges: {
        verified: 'Verified',
        redacted: 'Redacted',
        system: 'System',
        business: 'Business',
        endUser: 'End-User',
      },
      labels: {
        scope: 'Scope',
        source: 'Source',
        used: 'Used',
        times: 'times',
        facts: 'facts',
        ttl: 'TTL',
        days: 'days',
        permanent: 'Permanent',
      },
      tooltips: {
        edit: 'Edit',
        delete: 'Delete',
      },
      confirm: {
        deleteScope: 'Delete this scope? All associated facts will be removed.',
        deleteFact: 'Delete this fact?',
      },
      errors: {
        delete: 'Error while deleting',
        loadData: 'Error loading data',
        loadFacts: 'Error loading facts',
      },
    },
    endUsers: {
      title: 'End-Users (Clients)',
      tagline: 'Manage your identified clients and their personalized memory',
      searchPlaceholder: 'Search by name, email, external ID...',
      search: 'Search',
      newClient: 'New client',
      stats: {
        totalClients: 'Total Clients',
        active7d: 'Active (7d)',
        withEmail: 'With Email',
      },
      empty: {
        noResults: 'No clients found.',
        noClients: 'No clients registered. Clients will be created automatically upon their first identification.',
      },
      labels: {
        id: 'ID',
        username: 'Username',
        created: 'Created',
        seen: 'Seen',
        never: 'Never',
      },
      tooltips: {
        stats: 'Statistics',
        export: 'GDPR Export',
        anonymize: 'Anonymize',
        delete: 'Delete',
      },
      confirm: {
        delete: 'Delete {name}?',
        deleteWarning: 'All associated memory data will be deleted (GDPR).',
        anonymize: 'Anonymize {name}?',
        anonymizeWarning: 'Personal data will be deleted but statistics will be kept.',
      },
      errors: {
        loadStats: 'Error loading statistics',
        export: 'Error during export',
        delete: 'Error during deletion',
        anonymize: 'Error during anonymization',
      },
      modal: {
        statsTitle: 'Statistics',
        memoryScopes: 'Memory Scopes',
        memoryFacts: 'Memory Facts',
        externalId: 'External ID',
        email: 'Email',
        createdAt: 'Created on',
        lastActivity: 'Last activity',
        close: 'Close',
        newClientTitle: 'New Client',
        newClientInfo: 'Clients are created automatically upon their first identification via WordPress or JWT.',
        newClientApi: 'You can also create them manually via the API',
      },
    },
    email: {
      title: 'Email',
      tagline: 'Manage your email connections and AI agent auto-replies',
      observeTitle: 'Track automatic replies',
      observeBody:
        'Open Messages on the connection: Replied means the reply was sent (SendGrid), Failed shows the error, Pending a generated reply not sent yet. The counters on each card reflect what Totemium processed. Last check = last polling run (IMAP unread). If something blocks, an error also appears on the card.',
      messagesModalHint:
        'Replied = outbound reply sent. Failed = open detail (e.g. SendGrid domain).',
      detailReplySentAt: 'Reply sent at',
      refresh: 'Refresh',
      newConnection: 'New connection',
      connections: 'Your email connections',
      noConnections: 'No connections configured yet',
      connectionsCount: 'connection(s) configured',
      delete: {
        title: 'Delete connection',
        irreversible: 'This action is irreversible.',
        close: 'Close',
        confirm: 'Are you sure you want to delete the connection',
        warning: 'All associated messages and patterns will be deleted.',
        cancel: 'Cancel',
        deleting: 'Deleting…',
        deletePermanently: 'Delete permanently',
      },
      card: {
        processed: 'Processed',
        interval: 'Interval',
        lastCheck: 'Last check',
        totemiumActivity: 'Activity in Totemium',
        statReceivedShort: 'received',
        statRepliedShort: 'replied',
        statPendingShort: 'pending',
        enabled: '✓ Enabled',
        disabled: 'Disabled',
        auto: '🤖 Auto',
        manual: 'Manual',
        messages: 'Messages',
        patterns: 'Patterns',
        settings: 'Settings',
        delete: 'Delete',
      },
      empty: {
        title: 'No email connection',
        description: 'Connect an IMAP email account to allow your AI agents to automatically reply to emails.',
        addConnection: 'Add IMAP connection',
      },
      providers: {
        gmail: 'Gmail',
        outlook: 'Outlook',
        imap: 'IMAP',
      },
      editor: {
        titleNew: 'New IMAP connection',
        titleEdit: 'Edit',
        cancel: 'Cancel',
        saving: 'Saving...',
        save: 'Update',
        create: 'Create',
        sectionIdentity: 'Identity',
        emailLabel: 'Email address *',
        displayNameLabel: 'Display name',
        displayNamePlaceholder: 'Customer Support',
        agentLabel: 'AI Agent',
        agentNone: 'No agent',
        agentHelp: 'The agent will generate automatic email replies',
        sectionImap: 'IMAP Server',
        imapHostLabel: 'IMAP Host *',
        imapHostPlaceholder: 'imap.yourdomain.com',
        smtpHostLabel: 'SMTP Host',
        smtpHostPlaceholder: 'smtp.yourdomain.com',
        portLabel: 'Port',
        useTls: 'Use TLS/SSL',
        testReenterCredentials: 'To test the connection, please re-enter your credentials below',
        testBtn: 'Test connection',
        testing: 'Testing...',
        sectionAuth: 'Authentication',
        usernameLabel: 'Username',
        usernamePlaceholder: 'contact@yourdomain.com',
        usernameUnchanged: '(unchanged)',
        keepCurrentHint: 'Leave blank to keep the current value',
        passwordLabel: 'Password',
        sectionSettings: 'Settings',
        checkIntervalLabel: 'Check interval (minutes)',
        enabledLabel: 'Connection enabled',
        autoReplyLabel: 'AI auto-reply',
        sectionDomain: 'Domain verification',
        infoTitle: '💡 IMAP Configuration',
        infoPort993: 'Standard IMAP port with TLS:',
        infoPort587: 'Standard SMTP port with STARTTLS:',
        infoGmail: 'For Gmail, use an',
        infoGmailAppPassword: 'app password',
        infoImap: 'Make sure IMAP access is enabled in your email provider settings',
        errorEmailRequired: 'Email address is required',
        errorImapRequired: 'IMAP server is required',
        errorUsernameRequired: 'Username is required',
        errorPasswordRequired: 'Password is required',
      },
    },
    workflows: {
      title: 'Workflows',
      tagline: 'Automate tasks for your agents with triggers and actions',
      newWorkflow: 'New workflow',
      createWorkflow: 'Create workflow',
      searchPlaceholder: 'Search for a workflow...',
      allAgents: 'All agents',
      allStatuses: 'All statuses',
      active: 'Active',
      inactive: 'Inactive',
      delete: {
        title: 'Delete workflow',
        irreversible: 'This action is irreversible.',
        close: 'Close',
        confirm: 'Are you sure you want to delete',
        cancel: 'Cancel',
        delete: 'Delete',
      },
      errors: {
        load: 'Error loading data',
        toggle: 'Error during modification',
        delete: 'Error during deletion',
      },
      stats: {
        activeWorkflows: 'Active workflows',
        activeDescription: 'Workflows currently running',
        executionsToday: 'Executions today',
        executionsDescription: 'Automated tasks today',
        successRate: 'Success rate',
        successDescription: 'Over the last 24h',
        totalWorkflows: 'Total workflows',
        totalDescription: 'All created workflows',
      },
      empty: {
        title: 'No workflow',
        noResults: 'No workflow matches your criteria',
        createFirst: 'Create your first workflow to automate your agents',
      },
      card: {
        agent: 'Agent',
        executions: 'Executions',
        success: 'Success',
        failures: 'Failures',
        nextRun: 'Next run',
        view: 'View',
        edit: 'Edit',
        delete: 'Delete',
        enable: 'Enable',
        disable: 'Disable',
      },
      connectors: {
        schedule: 'Schedule',
        manual: 'Manual',
        webhook: 'Webhook',
        email: 'Email',
        email_imap: 'Email IMAP',
        rss_feed: 'RSS Feed',
        slack: 'Slack',
        webhook_out: 'Outgoing Webhook',
        unknown: 'Unknown',
      },
    },
  },
  es: {
    sidebar: {
      menu: 'Menú',
      system: 'Sistema',
      sectionOverview: 'Resumen',
      sectionKnowledges: 'Conocimientos',
      sectionAgentsDiscussions: 'Agentes y Messenger',
      sectionAdvanced: 'Avanzado',
      advancedMore: 'Más',
      advancedLess: 'Menos',
      badgePreview: 'Vista previa',
      badgeBeta: 'Beta',
      sharedApiKeys: 'Claves API compartidas',
      dashboard: 'Panel',
      knowledges: 'Bases de conocimiento',
      agents: 'Agentes IA',
      memory: 'Memoria de agentes',
      endUsers: 'Usuarios finales',
      conversations: 'Conversaciones',
      email: 'Correo',
      workflows: 'Automatización',
      messenger: 'Messenger',
      agencyDashboard: 'Espacio agencia',
      admin: 'Administración',
      configuration: 'Configuración',
      myAccount: 'Mi cuenta',
      logout: 'Cerrar sesión',
      openMenu: 'Abrir menú',
      closeMenu: 'Reducir menú',
    },
    header: {
      profile: 'Perfil',
      connected: 'Conectado',
      startGuide: 'Guía de inicio',
      documentation: 'Documentación',
      contactUs: 'Contáctenos',
      myAccount: 'Mi cuenta',
      logout: 'Cerrar sesión',
    },
    pageTitles: {
      dashboard: 'Panel de control',
      conversations: 'Conversaciones',
      conversationHistory: 'Historial',
      agents: 'Agentes IA',
      knowledges: 'Base de conocimientos',
      library: 'Biblioteca',
      catalog: 'Catálogo',
      administration: 'Administración',
      widgetConfig: 'Configuración de Widgets',
      branding: 'Branding',
      sendgrid: 'Notificaciones SendGrid',
      publicAgent: 'Agente Público',
      systemPrompts: 'Prompts del Sistema',
      paymentStripe: 'Pago Stripe',
      ollamaCloud: 'Ollama Cloud',
      configuration: 'Configuración',
      wordpress: 'WordPress',
      openai: 'OpenAI',
      anthropic: 'Anthropic',
      sendgridAgent: 'SendGrid (respuestas email agente)',
      users: 'Usuarios',
      models: 'Modelos',
      integrations: 'Integraciones',
      mcp: 'MCP',
      monitoring: 'Monitoreo',
      logs: 'Logs',
      logsMcp: 'Logs MCP',
      profile: 'Perfil',
      twoFA: 'Autenticación 2FA',
      workflows: 'Workflows',
      planManagement: 'Gestión de Planes',
      adminUsers: 'Usuarios Admin',
      adminAffiliate: 'Afiliación',
      pricing: 'Precios',
      myAccountPage: 'Mi Cuenta',
      memory: 'Memoria',
      endUsers: 'End-Users',
      email: 'Email',
    },
    affiliate: {
      navLabel: 'Afiliación',
      title: 'Programa de afiliación',
      subtitle: 'Comparte Totemium y gana comisión en suscripciones elegibles.',
      yourCode: 'Tu código',
      yourLink: 'Enlace para compartir',
      copy: 'Copiar',
      copied: 'Copiado',
      referrals: 'Referidos',
      payable: 'Pendiente de pago',
      paid: 'Ya abonado',
      connectNote: 'Pago',
      commissionsTitle: 'Historial de comisiones',
      emptyCommissions: 'Aún no hay comisiones.',
      plan: 'Plan',
      amount: 'Importe',
      docsLink: 'Condiciones del programa',
      recurringOn: 'Comisión en cada renovación',
      recurringOff: 'Solo la primera comisión por referido',
      contractTitle: 'Contrato de afiliación',
      contractSubtitle:
        'Las plataformas SaaS suelen exigir aceptación explícita antes de promocionar. Lee el texto y confirma.',
      contractVersionLabel: 'Versión del contrato',
      contractAcceptCheckbox:
        'Confirmo haber leído y acepto este contrato y las reglas del programa de afiliación.',
      contractAcceptButton: 'Aceptar y continuar',
      contractEmpty: '_Sin texto configurado por el administrador._',
      holdPeriodNote:
        'Retraso de pago: {days} días tras el registro del referido (fecha de atribución).',
      linkHiddenUntilContract: 'Acepta el contrato arriba para ver tu código y enlace.',
      pendingHold: 'En espera (plazo)',
      pendingHoldHint: 'Importe aún dentro del plazo tras el registro del referido.',
      payableAt: 'Pagadero desde',
      dashboardPrivacyNote:
        'Privacidad: solo ves un identificador técnico interno por referido; la identidad real la gestiona Totemium.',
      referralsSectionTitle: 'Mis referidos',
      referredUserIdColumn: 'ID referido',
      referredUserIdTooltip:
        'Identificador interno en Totemium del referido (no nominativo). Soporte puede relacionar este ID con una cuenta si hace falta.',
      referredUserIdHint:
        'Los referidos se muestran solo con ID interno, según nuestra política de privacidad.',
      attributedAt: 'Fecha de atribución',
      source: 'Origen',
      commissionsCount: 'Comisiones',
      totalCommissionCents: 'Total comisiones',
      lastCommissionAt: 'Última comisión',
      hasPaidBadge: 'Ya abonada',
      emptyReferrals: 'Aún no hay referidos registrados.',
      exportReferralsCsv: 'Exportar CSV',
      chartTitle: 'Comisiones por mes',
      chartEmpty: 'Aún no hay serie mensual (sin comisiones registradas).',
      statsAttributedLabel: 'Atribuciones (total)',
      statsWithCommissionLabel: 'Referidos con al menos una comisión',
      linkViewsSectionTitle: 'Vistas del enlace de referido',
      linkViewsHint:
        'Se cuenta una vista la primera vez que se abre el enlace con ?ref= en cada sesión del navegador. El sitio de origen (referrer HTTP) y los UTM se guardan si el navegador los envía.',
      linkViewsTotal: 'Vistas del enlace (total)',
      linkViewsLast30: 'Vistas (últimos 30 días)',
      linkViewsChartTitle: 'Vistas por mes',
      linkViewsShort: 'Vistas',
      topReferrersTitle: 'Origen del tráfico (referrers)',
      columnReferrerDomain: 'Origen',
      columnViewCount: 'Vistas',
    },
    modelsPlatformAdmin: {
      pageTitle: 'Modelos LLM (plataforma)',
      pageSubtitle:
        'Ollama: descarga modelos en el servidor. Para cada proveedor, activa los modelos ofrecidos a los tenants (filtro global y luego catálogo por workspace). Por defecto, OpenAI y Anthropic están desactivados hasta que actives los interruptores.',
      tabOllama: 'Ollama',
      tabOpenai: 'OpenAI',
      tabAnthropic: 'Anthropic',
      save: 'Guardar selección',
      saving: 'Guardando…',
      loadError: 'No se pudo cargar el catálogo de plataforma',
      saveError: 'No se pudo guardar',
      tenantSwitch: 'Ofrecido a tenants',
      sortLabel: 'Orden',
      pullTitle: 'Descargar un modelo',
      pullPlaceholder: 'ej. llama3.2:3b',
      pullButton: 'Descargar (stream)',
      pulling: 'Descargando…',
      pullStorageHint: 'Almacenamiento en el servidor Ollama (ej. /var/lib/totemai/ollama/).',
      backAdmin: 'Volver al admin',
      colName: 'Nombre',
      colSize: 'Tamaño',
      colModified: 'Modificado',
      colDigest: 'Digest',
      colActions: 'Acciones',
      defaultBadge: 'Predeterminado',
      setDefault: 'Definir predeterminado',
      currentDefault: 'Modelo predeterminado actual: {name}',
      deleting: 'Eliminando…',
      delete: 'Eliminar',
      noModels: 'Sin modelos locales.',
      loading: 'Cargando…',
    },
    adminAffiliate: {
      title: 'Programa de afiliación',
      subtitle: 'Ajustes en base de datos, afiliados, atribuciones, comisiones y Stripe Connect.',
      tabSettings: 'Ajustes',
      tabReferrers: 'Afiliados',
      tabAttributions: 'Atribuciones',
      tabCommissions: 'Comisiones',
      programEnabled: 'Programa activo',
      commissionRateBps: 'Tasa (basis points, ej. 1500 = 15%)',
      recurringCommissions: 'Comisión en cada renovación',
      maxCommissionMonths: 'Ventana de comisiones (meses, 0 = ilimitado)',
      minInvoiceCents: 'Importe mínimo factura (céntimos)',
      payableAfterReferralDays: 'Plazo antes de «pagable» (días tras registro del referido)',
      payableAfterReferralHint:
        '0 = inmediato si la factura aplica. Ej. 60 = comisiones en espera hasta 60 días tras la atribución (first-touch). Reduce riesgo de reembolso.',
      contractSection: 'Contrato afiliados (obligatorio si hay texto)',
      contractVersion: 'Versión del contrato (incr. para nueva aceptación)',
      contractVersionHint: 'Práctica SaaS: nueva versión = todos deben volver a aceptar.',
      contractMarkdown: 'Texto del contrato (Markdown)',
      contractMarkdownPlaceholder:
        'Sustituya {{PLACEHOLDERS}}; se precarga un borrador si el campo estaba vacío.',
      pendingHoldStatus: 'En espera de plazo (pending_hold)',
      payableAt: 'Pagadero desde',
      excludedPlanSlugs: 'Planes excluidos (slugs separados por comas)',
      cookieName: 'Nombre de la cookie de referido',
      cookieMaxAge: 'Duración cookie (segundos, mín. 60)',
      stripeConnectPayouts: 'Pagos automáticos Stripe Connect (Transfer)',
      stripeConnectCountry: 'País por defecto Express (ISO2)',
      defaultPayoutCurrency: 'Moneda del ledger (ISO3)',
      emailSearch: 'Filtrar por correo',
      emailColumn: 'Correo',
      publicCode: 'Código',
      referralsCount: 'Referidos',
      payableCents: 'Pendiente (¢)',
      paidCents: 'Pagado (¢)',
      suspend: 'Suspender',
      activate: 'Activar',
      rotateCode: 'Nuevo código',
      stripeOnboarding: 'Onboarding Stripe',
      total: 'Total',
      prev: 'Anterior',
      next: 'Siguiente',
      createAttribution: 'Crear atribución',
      attributionsCreateTitle: 'Nueva atribución',
      attributionsCreateHint:
        'Vincule manualmente afiliado y referido. Indique ID o correo por cada lado (al menos uno por persona).',
      attributionsCreateNeedBoth:
        'Indique un identificador (ID o correo) para el afiliado y para el referido.',
      attributionsFilterTitle: 'Filtrar la lista',
      attributionsFilterHint:
        'Filtre por ID y/o correo; vacío = todo. El ID y el correo del mismo rol deben ser la misma cuenta.',
      attributionsResetFilters: 'Restablecer filtros',
      attributionsListTitle: 'Atribuciones guardadas',
      newReferrerId: 'ID afiliado',
      newReferredId: 'ID referido',
      newReferrerEmail: 'Correo afiliado',
      newReferredEmail: 'Correo referido',
      filterReferrerId: 'Filtro ID afiliado',
      filterReferredId: 'Filtro ID referido',
      filterReferrerEmail: 'Filtro correo afiliado',
      filterReferredEmail: 'Filtro correo referido',
      suspended: 'Suspendido',
      stripeTransfer: 'Transferencia Stripe',
      markPaidStripe: 'Pago Stripe',
      filterStatus: 'Estado',
      allStatuses: 'Todos',
      payableOnly: 'Solo pendientes',
      exportCsv: 'Exportar CSV',
      refresh: 'Actualizar',
      markPaid: 'Marcar pagado',
      payoutRef: 'Referencia de pago',
      payoutRefPlaceholder: 'ej. transferencia 2026-04-05',
      referrer: 'Afiliado',
      referred: 'Referido',
      invoice: 'Factura Stripe',
    },
    footer: {
      rights: 'Todos los derechos reservados.',
    },
    common: {
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      search: 'Buscar',
      loading: 'Cargando...',
      noResults: 'Sin resultados',
      confirm: 'Confirmar',
      back: 'Volver',
      next: 'Siguiente',
      close: 'Cerrar',
      yes: 'Sí',
      no: 'No',
      actions: 'Acciones',
      status: 'Estado',
      name: 'Nombre',
      description: 'Descripción',
      date: 'Fecha',
      type: 'Tipo',
      active: 'Activo',
      inactive: 'Inactivo',
      enabled: 'Habilitado',
      disabled: 'Deshabilitado',
      selectLanguage: 'Seleccionar idioma',
      irreversibleAction: 'Esta acción es irreversible.',
      confirmDeletePrefix: '¿Seguro que quieres eliminar',
      errorWhileDeleting: 'Error al eliminar',
      deleteInProgress: 'Eliminando...',
      deletePermanently: 'Eliminar definitivamente',
    },

    dashboard: {
      loadStatsError: 'Error al cargar las estadísticas',

      cards: {
        indexedMediaTitle: 'Medios indexados',
        indexedMediaDescription: 'Número total de archivos procesados',
        embeddingsTitle: 'Embeddings',
        embeddingsDescription: 'Vectores disponibles para RAG',
        trackedStatusesTitle: 'Estados seguidos',
        trackedStatusesDescription: 'Estados de procesamiento activos',
        linkedCoursesTitle: 'Formaciones vinculadas',
        linkedCoursesDescription: 'Cursos o recorridos conectados',
      },

      recent: {
        title: 'Últimos medios ingeridos',
        description: 'Últimos contenidos procesados. Sigue su estado y la formación asociada.',
        table: {
          title: 'Título',
          status: 'Estado',
          course: 'Formación',
          date: 'Fecha',
        },
        empty: 'No hay medios disponibles por el momento.',
      },

      activity: {
        title: 'Actividad de los últimos 7 días',
        totalDescription: 'Total de medios procesados en los últimos siete días.',
      },

      statuses: {
        title: 'Estados activos',
        empty: 'Ningún estado rastreado.',
      },
    },

    agencyDashboard: {
      title: 'Dashboard de Agencia',
      subtitle: 'Vista global de todos sus espacios de trabajo',
      loading: 'Cargando...',
      error: 'Error al cargar los datos',
      notAgency: 'Esta página está reservada para usuarios del plan Agency',
      upgradeButton: 'Actualizar al plan Agency',
      pooledQuotas: 'Cuotas compartidas',
      pooledQuotasDescription: 'Sus cuotas (agentes, conversaciones, almacenamiento) se comparten entre todos sus espacios de trabajo. El total mostrado representa el uso global de su cuenta Agency.',
      unlimited: 'Ilimitado',
      thisMonth: 'este mes',
      items: 'elementos',
      workspace: 'espacio de trabajo',
      workspaces: 'espacios de trabajo',
      plan: 'Plan',
      preview: 'Vista previa',
      production: 'Producción',
      
      globalMetrics: {
        title: 'Métricas globales',
        agents: 'Agentes',
        storage: 'Almacenamiento',
        workspaces: 'Espacios de trabajo',
        conversations: 'Conversaciones',
        knowledge: 'Conocimientos',
        of: 'de',
      },

      workspacesList: {
        title: 'Sus espacios de trabajo',
        name: 'Nombre',
        agents: 'Agentes',
        storage: 'Almacenamiento',
        conversations: 'Conversaciones',
        knowledgeItems: 'Conocimientos',
        createdAt: 'Creado el',
        mode: 'Modo',
        preview: 'Vista previa',
        production: 'Producción',
      },
    },

    knowledges: {
      tagline: 'Gestiona tus colecciones y contenidos para enriquecer tus asistentes IA',
      collections: 'Colecciones',
      stats: 'Estadísticas',
      syncs: 'Sincronizaciones',

      panel: {
        orphanTitle: 'Contenidos sin colección',
        contentsOfPrefix: 'Contenidos de',
        allContents: 'Todos los contenidos',
        contentCount: 'contenido',
      },

      collectionsSidebar: {
        allContents: 'Todos los contenidos',
        withoutCollection: 'Sin colección',
        newCollection: 'Nueva colección',
        manual: 'Manual',
        wordpress: 'WordPress',
        deleteCollectionTitle: 'Eliminar colección',
        deleteCollectionWarning: 'Los contenidos asociados no se eliminarán, pero quedarán huérfanos.',
      },

      collectionCreate: {
        title: 'Nueva colección',
        subtitle: 'Crea un grupo para organizar tus contenidos',
        collectionTitleLabel: 'Título de la colección',
        placeholder: 'Ej: Formación de onboarding',
        titleRequired: 'El título es obligatorio',
        creationError: 'Error al crear',
        creating: 'Creando...',
        create: 'Crear colección',
        tipsTitle: 'Consejos',
        tip1: 'Agrupa por temática o formación para mayor claridad.',
        tip2: 'Las colecciones de WordPress se sincronizan automáticamente.',
        tip3: 'Podrás renombrar o eliminar esta colección más tarde.',
        kbLanguageLabel: 'Idioma del contenido (recuperación RAG)',
        kbLanguageHint: 'Indica el idioma en el que están tus documentos; el asistente puede seguir respondiendo en el idioma del usuario.',
      },

      kbContentLanguage: {
        label: 'Idioma del corpus',
        hint: 'Mejora la pertinencia del RAG. Déjalo sin definir para el valor predeterminado de la plataforma.',
        autoOption: 'Automático / sin definir',
        langFr: 'Francés (fr)',
        langEn: 'Inglés (en)',
        langEs: 'Español (es)',
        langDe: 'Alemán (de)',
        langIt: 'Italiano (it)',
        langPt: 'Portugués (pt)',
        langNl: 'Neerlandés (nl)',
        langZhHans: 'Chino simplificado (zh-hans)',
        sidebarTitle: 'KB',
      },

      contentsPanel: {
        allStatuses: 'Todos los estados',
        indexed: 'Indexados',
        transcribed: 'Transcritos',
        pending: 'Pendiente',
        transcribing: 'Transcribiendo...',
        indexing: 'Indexando...',
        inError: 'Con error',
        addContentShort: '+ Contenido',
        emptyTitle: 'Sin contenido',
        emptyOrphan: 'Todos tus contenidos están asociados a una colección.',
        emptyDefault: 'Añade tu primer contenido para enriquecer esta colección.',
        addFirstContent: '+ Añadir contenido',
        deleteContentTitle: 'Eliminar contenido',
        deleteContentWarning: 'Las transcripciones, embeddings y metadatos se eliminarán permanentemente.',
      },

      contentCard: {
        indexedAtPrefix: 'Indexado',
        viewDetails: 'Ver detalles',
        reindexClassic: 'Reindexar (segmentación clásica)',
        alreadyLLMSegmented: 'Ya segmentado por IA',
        llmSegmentation: 'Segmentación IA (mejor calidad RAG)',
        forceTranscribe: 'Forzar transcripción',
        yesterday: 'ayer',
        justNow: 'ahora mismo',
        minutesAgo: 'hace {n} min',
        hoursAgo: 'hace {n}h',
        daysAgo: 'hace {n}d',
      },

      contentDetail: {
        titleFallback: 'Detalles del contenido',
        cannotLoadDetails: 'No se pueden cargar los detalles',
        collection: 'Colección',
        withoutCollection: 'Sin colección',
        move: 'Mover',
        currentlyInPrefix: 'Actualmente en:',
        categories: 'Categorías',
        course: 'Formación',
        chunks: 'Chunks',
        embeddings: 'Embeddings',
        file: 'Archivo',
        size: 'Tamaño',
        mb: 'MB',
        embeddingsByCategory: 'Embeddings por categoría',
        transcription: 'Transcripción',
        characters: 'caracteres',
        language: 'Idioma',
        noTranscription: '— No hay transcripción disponible —',
        transcriptionUnavailable: 'Transcripción no disponible',
        downloadTranscription: 'Descargar transcripción',
        downloadTxt: 'Descargar .txt',
        reindex: 'Reindexar',
        llmSegmentation: 'Segmentación IA',
        forceTranscribe: 'Forzar transcripción',
      },

      statsDrawer: {
        title: 'Estadísticas',
        subtitle: 'Resumen de tu base de conocimientos',
        collections: 'Colecciones',
        contents: 'Contenidos',
        total: 'Total',
        manuals: 'Manuales',
        wordpress: 'WordPress',
        orphanContents: 'Contenidos huérfanos',
        ready: 'Listos',
        indexed: 'Indexados',
        transcribed: 'Transcritos',
        processing: 'En proceso',
        pending: 'Pendiente',
        errors: 'Errores',
        globalHealth: 'Salud global',
        usableContents: 'Contenidos utilizables',
        healthHint: '{ready} contenidos de {total} están listos para ser usados por tus agentes.',
        byStatus: 'Distribución por estado',
      },

      wpImport: {
        title: 'Importar desde WordPress',
        chooseContentType: 'Elige el tipo de contenido',
        selectContentsPrefix: 'Selecciona',
        confirmImport: 'Confirmar importación',
        importing: 'Importando...',
        completed: 'Importación terminada',
        error: 'Error',
        availableQuota: 'Cuota disponible',
        credits: 'créditos',
        selected: 'seleccionado',
        continue: 'Continuar →',
        quotaEnough: '✓ Cuota suficiente',
        quotaNotEnough: '✗ Cuota insuficiente ({n} contenidos de más)',
        back: 'Volver',
        launching: 'Iniciando...',
        importN: 'Importar {n} contenido{s}',
        editSelection: 'Modificar selección',
        importSummary: 'Resumen de importación',
        selectedContents: 'Contenidos seleccionados',
        totalChars: 'Total de caracteres',
        requiredCredits: 'Créditos necesarios',
        creditsAfter: 'Créditos tras importar',
        quotaAfter: 'Cuota tras importar',
        importPossible: '✅ Importación posible',
        quotaExceeded: '⚠️ Cuota superada en {n} créditos',
        importOptions: 'Opciones de importación',
        destinationCollection: 'Colección de destino',
        autoCreate: 'Crear automáticamente',
        autoCreateFromCourses: 'Crear colecciones desde cursos de WordPress',
        items: 'elementos',
        item: 'elemento',
        notAvailable: '(no disponible)',
        selectAll: 'Seleccionar todo',
        none: 'Ninguno',
        availableSuffix: 'disponibles',
        noTitle: '(Sin título)',
        modified: 'Modificado',
        imported: 'Importado',
        charCount: '{n} caracteres',
        approxChars: '~ caracteres',
        loadMore: 'Cargar más',
        cancelImport: 'Cancelar importación',
        importWithErrors: 'Importación completada con errores',
        importDone: '¡Importación completada!',
        importedSuccess: '{n} contenido{s} importado{s} con éxito',
        success: 'Éxito',
        failed: 'Fallidos',
      },
      upload: {
        title: 'Añadir contenido',
        description: 'Importa un nuevo medio: será transcrito e indexado automáticamente.',
        close: 'Cerrar',
        collection: 'Colección',
        course: 'Curso WordPress (opcional)',
        choose: '— elegir —',
        advice: 'Recomendado: vincula tu contenido a una colección para optimizar el RAG.',
        courseHelp: 'Si no se selecciona ninguna colección, vincula el medio a un curso WordPress.',
        dropzoneTitle: 'Arrastra y suelta tus archivos aquí, o haz clic para explorar.',
        formats: 'Formatos aceptados: mp3, wav, mp4, mov, txt, md, pdf.',
        filesSelected: '{n} archivo(s) seleccionado(s)',
        uploading: 'Subida en curso…',
        completed: 'Subida completada',
        upload: 'Subir',
        reset: 'Reiniciar',
        footer: 'Los contenidos enviados aparecerán en la biblioteca después de la indexación. Monitoriza su estado desde la página de contenidos.',
        errorLoadSubjects: 'Error al cargar temas',
        errorSelectFile: 'Selecciona al menos un archivo',
        success: '{n} archivo(s) subido(s) con éxito',
        partialSuccess: '{success} exitoso(s), {error} fallido(s)',
        mb: 'MB',
      },
    },
    agents: {
      title: 'Tus agentes',
      tagline: 'Gestiona tus agentes IA y su configuración',
      statsDrawerTitle: 'Panel de agentes',
      statsDrawerSubtitle: 'Seguimiento de tus cuotas y agentes más activos.',
      createAgent: 'Crear nuevo agente',
      statistics: 'Estadísticas',
      loading: 'Cargando agentes…',
      noAgents: 'Aún no hay agentes. Crea tu primer asistente definiendo su personalidad, icono y bases de conocimiento.',
      lastUpdated: 'Última actualización',
      quotaBadge: {
        active: 'activo',
        max: 'máx',
        quotaReached: 'Cuota alcanzada',
      },
      deleteModal: {
        title: 'Eliminar agente',
        warning: 'Esta acción elimina permanentemente el agente y sus estadísticas.',
        linkedSubjectsWarning: 'El agente está vinculado a {n} tema(s). Los medios permanecerán accesibles pero el agente ya no podrá responder conversaciones.',
        noSubjectsWarning: 'El agente se eliminará inmediatamente de tus integraciones (widget de chat, API, etc.).',
      },
      agentCard: {
        active: 'Activo',
        inactive: 'Inactivo',
        messages: 'Mensajes',
        docs: 'Docs',
        ai: 'IA',
        updated: 'Actualizado',
        useInChat: 'Usar en chat',
        history: 'Historial',
        edit: 'Editar',
        deactivate: 'Desactivar',
        activate: 'Activar',
        mcp: 'MCP',
        assignEmail: 'Asignar email',
        changeIcon: 'Cambiar icono',
        uploading: 'Subiendo…',
        delete: 'Eliminar',
        deleting: 'Eliminando…',
      },
      stats: {
        activeAgents: 'Agentes activos',
        activeAgentsDesc: 'Agentes listos para responder en el chat',
        activeAgentsEmpty: 'Crea tu primer agente personalizado',
        messagesSent: 'Mensajes enviados',
        messagesRemaining: 'Quedan {n} mensajes',
        noLimit: 'Sin límite definido',
        globalQuota: 'Cuota global',
        limitLabel: 'Límite del propietario',
        unlimitedPlan: 'Plan ilimitado',
        lastUpdate: 'Última actualización',
        noAgentYet: 'Aún no hay agentes',
        recentAgent: 'Agente más reciente',
        usageGlobal: 'Uso global',
        messagesOrg: 'mensajes enviados por la organización',
        totalAgents: 'Total agentes',
        knowledgeBases: 'Bases de conocimiento',
        aiUsed: 'Inteligencias usadas',
        totalMessagesByAgents: 'Total mensajes por agentes',
        globalQuotaTitle: 'Cuota global',
        messagesAllowed: 'mensajes permitidos',
        utilization: 'Utilización',
        unlimited: 'Ilimitado',
        remainingMessages: 'Quedan {n} mensajes en el período.',
        lastAgentCreated: 'Último agente creado',
        mostActiveAgents: 'Agentes más solicitados',
        top5Period: 'Top 5 en el período actual',
        noMessagesYet: 'Aún no se han enviado mensajes.',
        maxLabel: 'máx',
        noCap: 'Sin límite',
        docsSuffix: 'doc(s)',
        messagesSuffix: 'mensajes',
      },
      sandbox: {
        title: 'Sandbox de agente',
        subtitle: 'Configura el agente y pruébalo en el playground.',
        quotaPreserved: 'Cuota preservada',
        settings: 'Ajustes',
        playgroundTitle: 'Playground sandbox',
        playgroundSubtitle: 'Haz preguntas en modo sandbox sin consumir cuota.',
        close: 'Cerrar',
        save: 'Guardar',
        saving: 'Guardando…',
      },
      errors: {
        loadAgents: 'Error al cargar agentes',
        createAgent: 'Error al crear agente',
        updateAgent: 'Error al actualizar agente',
        deleteAgent: 'Eliminación fallida',
        toggleActivation: 'Error durante activación/desactivación',
        quotaReached: 'Cuota de agentes activos alcanzada. Desactiva un agente para activar otro.',
        uploadIcon: 'Error al subir icono',
      },
      teams: {
        header: 'Equipos',
        allAgents: 'Todos los agentes',
        noTeam: 'Sin equipo',
        newTeam: 'Nuevo equipo',
        deleteTitle: 'Eliminar equipo',
        deleteWarning: 'Los agentes de este equipo quedarán huérfanos (sin equipo).',
        createModal: {
          title: 'Nuevo equipo',
          subtitle: 'Crea un grupo para organizar tus agentes',
          close: 'Cerrar',
          nameLabel: 'Nombre del equipo',
          namePlaceholder: 'Ej: Soporte al cliente',
          creating: 'Creando...',
          create: 'Crear equipo',
          errorRequired: 'El título es obligatorio',
          errorCreate: 'Error al crear el equipo',
          tipsTitle: 'Consejos',
          tip1: 'Agrupa tus agentes por función o departamento.',
          tip2: 'Los agentes sin equipo aparecerán en "Sin equipo".',
          tip3: 'Podrás renombrar o eliminar este equipo más tarde.',
        },
      },
      modelPicker: {
        browse: 'Explorar…',
        title: 'Elegir modelo',
        search: 'Buscar…',
        tabOllama: 'Ollama',
        tabOpenai: 'OpenAI',
        tabAnthropic: 'Anthropic',
        emptyTab: 'Sin modelos',
        noMatch: 'Sin resultados',
        apply: 'Aplicar',
        cancel: 'Cancelar',
        loading: 'Cargando…',
      },
      llmCatalog: {
        title: 'Catálogo LLM del workspace',
        subtitle:
          'Marca los modelos ofrecidos a los miembros. Mientras no haya al menos una oferta activa por proveedor, se muestra la lista completa (comportamiento por defecto).',
        save: 'Guardar',
        saving: 'Guardando…',
        loadError: 'No se pudo cargar el catálogo',
        saveError: 'No se pudo guardar el catálogo',
        byokNote:
          'OpenAI y Anthropic: se necesita una clave API BYOK en este workspace para usar estos modelos en los agentes.',
        sortLabel: 'Orden',
        enabledLabel: 'Ofrecer',
        colModel: 'Modelo',
        noKeyBadge: 'Sin clave',
        workspaceTab: 'Modelos LLM',
        workspaceTabDesc: 'Oferta visible para miembros',
        errForbidden: 'No tienes permiso para gestionar este catálogo.',
        errPayload: 'Demasiadas entradas (límite 500).',
        errUnknownModel: 'Modelo o proveedor no válido.',
      },
      agentEditor: {
        titleNew: 'Nuevo agente',
        titleEdit: 'Editar',
        cancel: 'Cancelar',
        saving: 'Guardando...',
        save: 'Actualizar',
        create: 'Crear',
        tabGeneral: 'General',
        tabKnowledge: 'Base de conocimiento',
        tabMemory: '🧠 Memoria',
        sectionGeneral: 'Información general',
        nameLabel: 'Nombre',
        namePlaceholder: 'Ej: Agente de soporte',
        subtitleLabel: 'Subtítulo',
        subtitlePlaceholder: 'Ej: Experto en soporte Totemium',
        iconLabel: 'Icono',
        chooseImage: 'Elegir imagen',
        instructionsLabel: 'Instrucciones',
        instructionsPlaceholder: 'Describe el rol y el comportamiento del agente...',
        hideTemplates: '✕ Ocultar plantillas',
        changeTemplate: '📚 Cambiar plantilla',
        messageLimitLabel: 'Límite de mensajes',
        messageLimitPlaceholder: 'Ilimitado',
        messageLimitHelp: 'Número máximo de mensajes por conversación',
        sectionAI: 'Inteligencia artificial',
        modelLabel: '🧠 Modelo IA',
        modelDefault: 'Por defecto (sistema)',
        topKLabel: 'Top K (RAG)',
        topKHelp: 'Por defecto: 10 — Mayor = más contexto pero más lento',
        rerankLabel: 'Rerank Top N',
        rerankHelp: 'Por defecto: 5 — Número de documentos más relevantes conservados',
        strictLabel: '🎯 Respuestas estrictas',
        strictHelp: 'El asistente SOLO responderá con información de tu base de conocimiento',
        sectionTeam: 'Equipo',
        teamLabel: 'Asignar a un equipo',
        teamNone: 'Sin equipo',
        sectionAdminPrompt: '🔧 Admin: System Prompt',
        adminPromptLabel: 'Override del prompt del sistema',
        adminPromptDefault: 'Prompt por defecto',
        adminPromptHelp: 'Solo admin — reemplaza el prompt del sistema global',
        sectionKnowledge: 'Base de conocimiento',
        knowledgeHelp: 'Selecciona los documentos que el agente puede consultar para responder preguntas',
        noKnowledge: 'No hay base de conocimiento disponible',
        noKnowledgeHint: 'Crea sujetos en la sección Documentos',
        selected: 'Seleccionados',
        sectionMemory: '🧠 Memoria Perpetua',
        memoryBusiness: '💼 Memoria Business (Tenant)',
        memoryBusinessHelp: 'Activa la memoria compartida para tu conocimiento empresarial y preferencias',
        memoryEndUser: '👤 Memoria End-User (Clientes)',
        memoryEndUserHelp: 'Memoriza información específica por cliente identificado',
        scopesTitle: '📚 Scopes Asignados',
        noScopes: 'No hay scope disponible. Crea uno en la página',
        scopeMemoryLink: 'Memoria',
        scopeNoneSelected: '💡 Ningún scope seleccionado - se usarán todos los scopes business',
        scopeSelected: '✓ {n} scope(s) seleccionado(s)',
        memoryPageHint: '💡 Gestiona tus scopes y hechos de memoria en la página',
        errorNameRequired: 'El nombre es obligatorio',
        errorSave: 'Error al guardar',
        agentTypeLabel: '🎭 Tipo de agente',
        agentTypePlaceholder: 'Elegir un tipo de agente...',
        templateRecommended: 'Plantillas recomendadas',
        templateOthers: 'Otras plantillas',
        templateCount: '{n} plantilla{s} disponible{s}',
        templateNoAvailable: 'No hay plantillas disponibles para este tipo de agente',
        templateTipTitle: 'Consejo',
        templateTipBody: 'Puedes usar una plantilla como base y personalizarla en el campo Instrucciones. Las plantillas están optimizadas para cada tipo de agente.',
        levelBasic: 'Básico',
        levelAdvanced: 'Avanzado',
        levelPremium: 'Premium',
        badgeRecommended: 'Recomendado',
        badgeUsed: 'Usado',
        btnPreview: 'Vista previa',
        btnHide: 'Ocultar',
        btnUse: 'Usar',
        labelPopularity: 'Popularidad',
      },
    },
    conversations: {
      title: 'Conversaciones',
      historyForAgent: 'Historial · {name}',
      backToAgents: 'Agentes',
      loading: 'Cargando conversaciones...',
      errorLoading: 'Error al cargar las conversaciones',
      noConversations: 'Sin conversaciones',
      searchPlaceholder: 'Buscar...',
      filters: 'Filtros',
      hideFilters: 'Ocultar',
      allSources: 'Todos',
      whatsApp: 'WhatsApp',
      widgetExt: 'Widget Ext',
      widgetInt: 'Widget Int',
      filteredBy: 'Filtrado por:',
      allAgents: 'Todos los agentes',
      allUsers: 'Todos los usuarios',
      allPeriods: 'Todo período',
      today: 'Hoy',
      thisWeek: 'Esta semana',
      thisMonth: 'Este mes',
      allMessages: 'Todos los mensajes',
      short: 'Cortas (1-3 msg)',
      medium: 'Medianas (4-10 msg)',
      long: 'Largas (10+ msg)',
      sortBy: {
        updatedAt: 'Última actividad',
        createdAt: 'Fecha de creación',
        title: 'Título',
      },
      sortOrder: {
        desc: 'Descendente',
        asc: 'Ascendente',
      },
      favoritesOnly: 'Solo favoritos',
      resetFilters: 'Restablecer filtros',
      realtime: 'Tiempo real',
      conversationsCount: 'conversación(es)',
      agent: 'Agente',
      messages: 'mensaje(s)',
      sources: {
        whatsapp: 'WhatsApp',
        widgetExternal: 'Widget externo',
        widgetInternal: 'Widget interno',
      },
      humanTakeover: {
        human: 'Humano',
        auto: 'Auto',
        takeover: 'Tomar control',
        release: 'Soltar control',
        takeoverTitle: 'Tomar control (desactivar agente)',
        releaseTitle: 'Soltar control (reactivar agente)',
      },
      favorite: {
        add: 'Añadir a favoritos',
        remove: 'Quitar de favoritos',
      },
      delete: {
        title: 'Eliminar conversación',
        confirm: '¿Seguro que quieres eliminar esta conversación?',
        error: 'Error al eliminar',
      },
      resume: {
        title: 'Continuar en chat',
        success: '¡Conversación cargada! Abre el ChatWidget para continuar.',
      },
      toast: {
        newMessage: 'Nuevo mensaje',
        takeoverActivated: 'Takeover activado',
        agentReactivated: 'Agente reactivado',
        autoTakeover: 'Auto-takeover detectado',
      },
      time: {
        justNow: 'ahora mismo',
        minutesAgo: 'hace {n} min',
        hoursAgo: 'hace {n}h',
        daysAgo: 'hace {n}d',
      },
    },
    memory: {
      title: 'Memoria',
      tagline: 'Gestiona la memoria perpetua de tus agentes',
      tabs: {
        facts: 'Hechos',
        scopes: 'Scopes',
        categories: 'Categorías',
      },
      filters: {
        search: 'Búsqueda',
        searchPlaceholder: 'Buscar un hecho...',
        scope: 'Scope',
        allScopes: 'Todos los scopes',
        category: 'Categoría',
        allCategories: 'Todas las categorías',
      },
      buttons: {
        newFact: 'Nuevo hecho',
        newScope: 'Nuevo scope',
      },
      empty: {
        facts: 'No se encontraron hechos. Crea tu primer hecho de memoria.',
      },
      badges: {
        verified: 'Verificado',
        redacted: 'Oculto',
        system: 'Sistema',
        business: 'Business',
        endUser: 'End-User',
      },
      labels: {
        scope: 'Scope',
        source: 'Fuente',
        used: 'Usado',
        times: 'veces',
        facts: 'hechos',
        ttl: 'TTL',
        days: 'días',
        permanent: 'Permanente',
      },
      tooltips: {
        edit: 'Editar',
        delete: 'Eliminar',
      },
      confirm: {
        deleteScope: '¿Eliminar este scope? Todos los hechos asociados serán eliminados.',
        deleteFact: '¿Eliminar este hecho?',
      },
      errors: {
        delete: 'Error al eliminar',
        loadData: 'Error al cargar los datos',
        loadFacts: 'Error al cargar los hechos',
      },
    },
    endUsers: {
      title: 'End-Users (Clientes)',
      tagline: 'Gestiona tus clientes identificados y su memoria personalizada',
      searchPlaceholder: 'Buscar por nombre, email, ID externo...',
      search: 'Buscar',
      newClient: 'Nuevo cliente',
      stats: {
        totalClients: 'Total Clientes',
        active7d: 'Activos (7d)',
        withEmail: 'Con Email',
      },
      empty: {
        noResults: 'No se encontraron clientes.',
        noClients: 'No hay clientes registrados. Los clientes se crearán automáticamente en su primera identificación.',
      },
      labels: {
        id: 'ID',
        username: 'Usuario',
        created: 'Creado',
        seen: 'Visto',
        never: 'Nunca',
      },
      tooltips: {
        stats: 'Estadísticas',
        export: 'Exportar RGPD',
        anonymize: 'Anonimizar',
        delete: 'Eliminar',
      },
      confirm: {
        delete: '¿Eliminar {name}?',
        deleteWarning: 'Todos los datos de memoria asociados serán eliminados (RGPD).',
        anonymize: '¿Anonimizar {name}?',
        anonymizeWarning: 'Los datos personales serán eliminados pero las estadísticas se conservarán.',
      },
      errors: {
        loadStats: 'Error al cargar las estadísticas',
        export: 'Error al exportar',
        delete: 'Error al eliminar',
        anonymize: 'Error al anonimizar',
      },
      modal: {
        statsTitle: 'Estadísticas',
        memoryScopes: 'Scopes de Memoria',
        memoryFacts: 'Hechos de Memoria',
        externalId: 'ID Externo',
        email: 'Email',
        createdAt: 'Creado el',
        lastActivity: 'Última actividad',
        close: 'Cerrar',
        newClientTitle: 'Nuevo Cliente',
        newClientInfo: 'Los clientes se crean automáticamente en su primera identificación vía WordPress o JWT.',
        newClientApi: 'También puedes crearlos manualmente vía la API',
      },
    },
    email: {
      title: 'Email',
      tagline: 'Gestiona tus conexiones email y las respuestas automáticas de agentes IA',
      observeTitle: 'Seguir las respuestas automáticas',
      observeBody:
        'Abre « Mensajes » en la conexión: « Respondido » confirma el envío (SendGrid), « Fallo » muestra el error, « Pendiente » una respuesta generada no enviada. Los contadores en cada tarjeta reflejan lo procesado en Totemium. « Última verif. » = último polling (no leídos IMAP). Si hay bloqueo, verás un error en la tarjeta.',
      messagesModalHint:
        '« Respondido » = respuesta enviada. « Fallo » = ver detalle (p. ej. dominio SendGrid).',
      detailReplySentAt: 'Respuesta enviada el',
      refresh: 'Actualizar',
      newConnection: 'Nueva conexión',
      connections: 'Tus conexiones email',
      noConnections: 'Sin conexiones configuradas aún',
      connectionsCount: 'conexión(es) configurada(s)',
      delete: {
        title: 'Eliminar conexión',
        irreversible: 'Esta acción es irreversible.',
        close: 'Cerrar',
        confirm: '¿Seguro que quieres eliminar la conexión',
        warning: 'Todos los mensajes y patterns asociados serán eliminados.',
        cancel: 'Cancelar',
        deleting: 'Eliminando…',
        deletePermanently: 'Eliminar definitivamente',
      },
      card: {
        processed: 'Procesados',
        interval: 'Intervalo',
        lastCheck: 'Última verif',
        totemiumActivity: 'Actividad en Totemium',
        statReceivedShort: 'recibidos',
        statRepliedShort: 'respondidos',
        statPendingShort: 'pendientes',
        enabled: '✓ Activado',
        disabled: 'Desactivado',
        auto: '🤖 Auto',
        manual: 'Manual',
        messages: 'Mensajes',
        patterns: 'Patterns',
        settings: 'Ajustes',
        delete: 'Eliminar',
      },
      empty: {
        title: 'Sin conexión email',
        description: 'Conecta una cuenta email IMAP para permitir que tus agentes IA respondan automáticamente a los emails.',
        addConnection: 'Añadir conexión IMAP',
      },
      providers: {
        gmail: 'Gmail',
        outlook: 'Outlook',
        imap: 'IMAP',
      },
      editor: {
        titleNew: 'Nueva conexión IMAP',
        titleEdit: 'Editar',
        cancel: 'Cancelar',
        saving: 'Guardando...',
        save: 'Actualizar',
        create: 'Crear',
        sectionIdentity: 'Identidad',
        emailLabel: 'Dirección email *',
        displayNameLabel: 'Nombre de visualización',
        displayNamePlaceholder: 'Soporte al Cliente',
        agentLabel: 'Agente IA',
        agentNone: 'Sin agente',
        agentHelp: 'El agente generará las respuestas automáticas a los emails',
        sectionImap: 'Servidor IMAP',
        imapHostLabel: 'Host IMAP *',
        imapHostPlaceholder: 'imap.tudominio.com',
        smtpHostLabel: 'Host SMTP',
        smtpHostPlaceholder: 'smtp.tudominio.com',
        portLabel: 'Puerto',
        useTls: 'Usar TLS/SSL',
        testReenterCredentials: 'Para probar la conexión, vuelve a introducir tus credenciales abajo',
        testBtn: 'Probar conexión',
        testing: 'Probando...',
        sectionAuth: 'Autenticación',
        usernameLabel: 'Nombre de usuario',
        usernamePlaceholder: 'contacto@tudominio.com',
        usernameUnchanged: '(sin cambios)',
        keepCurrentHint: 'Deja en blanco para conservar el valor actual',
        passwordLabel: 'Contraseña',
        sectionSettings: 'Ajustes',
        checkIntervalLabel: 'Intervalo de verificación (minutos)',
        enabledLabel: 'Conexión activada',
        autoReplyLabel: 'Respuesta automática IA',
        sectionDomain: 'Verificación de dominio',
        infoTitle: '💡 Configuración IMAP',
        infoPort993: 'Puerto IMAP estándar con TLS:',
        infoPort587: 'Puerto SMTP estándar con STARTTLS:',
        infoGmail: 'Para Gmail, usa una',
        infoGmailAppPassword: 'contraseña de aplicación',
        infoImap: 'Verifica que el acceso IMAP esté activado en los ajustes de tu proveedor de email',
        errorEmailRequired: 'La dirección email es obligatoria',
        errorImapRequired: 'El servidor IMAP es obligatorio',
        errorUsernameRequired: 'El nombre de usuario es obligatorio',
        errorPasswordRequired: 'La contraseña es obligatoria',
      },
    },
    workflows: {
      title: 'Workflows',
      tagline: 'Automatiza tareas para tus agentes con desencadenadores y acciones',
      newWorkflow: 'Nuevo workflow',
      createWorkflow: 'Crear workflow',
      searchPlaceholder: 'Buscar un workflow...',
      allAgents: 'Todos los agentes',
      allStatuses: 'Todos los estados',
      active: 'Activos',
      inactive: 'Inactivos',
      delete: {
        title: 'Eliminar workflow',
        irreversible: 'Esta acción es irreversible.',
        close: 'Cerrar',
        confirm: '¿Seguro que quieres eliminar',
        cancel: 'Cancelar',
        delete: 'Eliminar',
      },
      errors: {
        load: 'Error al cargar los datos',
        toggle: 'Error al modificar',
        delete: 'Error al eliminar',
      },
      stats: {
        activeWorkflows: 'Workflows activos',
        activeDescription: 'Workflows en ejecución',
        executionsToday: 'Ejecuciones hoy',
        executionsDescription: 'Tareas automatizadas hoy',
        successRate: 'Tasa de éxito',
        successDescription: 'En las últimas 24h',
        totalWorkflows: 'Total workflows',
        totalDescription: 'Todos los workflows creados',
      },
      empty: {
        title: 'Sin workflow',
        noResults: 'Ningún workflow coincide con tus criterios',
        createFirst: 'Crea tu primer workflow para automatizar tus agentes',
      },
      card: {
        agent: 'Agente',
        executions: 'Ejecuciones',
        success: 'Éxitos',
        failures: 'Fallos',
        nextRun: 'Próxima ejecución',
        view: 'Ver',
        edit: 'Editar',
        delete: 'Eliminar',
        enable: 'Activar',
        disable: 'Desactivar',
      },
      connectors: {
        schedule: 'Programación',
        manual: 'Manual',
        webhook: 'Webhook',
        email: 'Email',
        email_imap: 'Email IMAP',
        rss_feed: 'Feed RSS',
        slack: 'Slack',
        webhook_out: 'Webhook saliente',
        unknown: 'Desconocido',
      },
    },
  },
};

export interface AppTranslations {
  sidebar: {
    menu: string;
    system: string;
    sectionOverview: string;
    sectionKnowledges: string;
    sectionAgentsDiscussions: string;
    sectionAdvanced: string;
    advancedMore: string;
    advancedLess: string;
    badgePreview: string;
    badgeBeta: string;
    sharedApiKeys: string;
    dashboard: string;
    knowledges: string;
    agents: string;
    memory: string;
    endUsers: string;
    conversations: string;
    email: string;
    workflows: string;
    messenger: string;
    agencyDashboard: string;
    admin: string;
    configuration: string;
    myAccount: string;
    logout: string;
    openMenu: string;
    closeMenu: string;
  };
  header: {
    profile: string;
    connected: string;
    startGuide: string;
    documentation: string;
    contactUs: string;
    myAccount: string;
    logout: string;
  };
  pageTitles: {
    dashboard: string;
    conversations: string;
    conversationHistory: string;
    agents: string;
    knowledges: string;
    library: string;
    catalog: string;
    administration: string;
    widgetConfig: string;
    branding: string;
    sendgrid: string;
    publicAgent: string;
    systemPrompts: string;
    paymentStripe: string;
    ollamaCloud: string;
    configuration: string;
    wordpress: string;
    openai: string;
    anthropic: string;
    sendgridAgent: string;
    users: string;
    models: string;
    integrations: string;
    mcp: string;
    monitoring: string;
    logs: string;
    logsMcp: string;
    profile: string;
    twoFA: string;
    workflows: string;
    planManagement: string;
    adminUsers: string;
    adminAffiliate: string;
    pricing: string;
    myAccountPage: string;
    memory: string;
    endUsers: string;
    email: string;
  };
  affiliate: {
    navLabel: string;
    title: string;
    subtitle: string;
    yourCode: string;
    yourLink: string;
    copy: string;
    copied: string;
    referrals: string;
    payable: string;
    paid: string;
    connectNote: string;
    commissionsTitle: string;
    emptyCommissions: string;
    plan: string;
    amount: string;
    docsLink: string;
    recurringOn: string;
    recurringOff: string;
    contractTitle: string;
    contractSubtitle: string;
    contractVersionLabel: string;
    contractAcceptCheckbox: string;
    contractAcceptButton: string;
    contractEmpty: string;
    holdPeriodNote: string;
    linkHiddenUntilContract: string;
    pendingHold: string;
    pendingHoldHint: string;
    payableAt: string;
    dashboardPrivacyNote: string;
    referralsSectionTitle: string;
    referredUserIdColumn: string;
    referredUserIdTooltip: string;
    referredUserIdHint: string;
    attributedAt: string;
    source: string;
    commissionsCount: string;
    totalCommissionCents: string;
    lastCommissionAt: string;
    hasPaidBadge: string;
    emptyReferrals: string;
    exportReferralsCsv: string;
    chartTitle: string;
    chartEmpty: string;
    statsAttributedLabel: string;
    statsWithCommissionLabel: string;
    linkViewsSectionTitle: string;
    linkViewsHint: string;
    linkViewsTotal: string;
    linkViewsLast30: string;
    linkViewsChartTitle: string;
    linkViewsShort: string;
    topReferrersTitle: string;
    columnReferrerDomain: string;
    columnViewCount: string;
  };
  modelsPlatformAdmin: {
    pageTitle: string;
    pageSubtitle: string;
    tabOllama: string;
    tabOpenai: string;
    tabAnthropic: string;
    save: string;
    saving: string;
    loadError: string;
    saveError: string;
    tenantSwitch: string;
    sortLabel: string;
    pullTitle: string;
    pullPlaceholder: string;
    pullButton: string;
    pulling: string;
    pullStorageHint: string;
    backAdmin: string;
    colName: string;
    colSize: string;
    colModified: string;
    colDigest: string;
    colActions: string;
    defaultBadge: string;
    setDefault: string;
    currentDefault: string;
    deleting: string;
    delete: string;
    noModels: string;
    loading: string;
  };
  adminAffiliate: {
    title: string;
    subtitle: string;
    tabSettings: string;
    tabReferrers: string;
    tabAttributions: string;
    tabCommissions: string;
    programEnabled: string;
    commissionRateBps: string;
    recurringCommissions: string;
    maxCommissionMonths: string;
    minInvoiceCents: string;
    payableAfterReferralDays: string;
    payableAfterReferralHint: string;
    contractSection: string;
    contractVersion: string;
    contractVersionHint: string;
    contractMarkdown: string;
    contractMarkdownPlaceholder: string;
    pendingHoldStatus: string;
    payableAt: string;
    excludedPlanSlugs: string;
    cookieName: string;
    cookieMaxAge: string;
    stripeConnectPayouts: string;
    stripeConnectCountry: string;
    defaultPayoutCurrency: string;
    emailSearch: string;
    emailColumn: string;
    publicCode: string;
    referralsCount: string;
    payableCents: string;
    paidCents: string;
    suspend: string;
    activate: string;
    rotateCode: string;
    stripeOnboarding: string;
    total: string;
    prev: string;
    next: string;
    createAttribution: string;
    attributionsCreateTitle: string;
    attributionsCreateHint: string;
    attributionsCreateNeedBoth: string;
    attributionsFilterTitle: string;
    attributionsFilterHint: string;
    attributionsResetFilters: string;
    attributionsListTitle: string;
    newReferrerId: string;
    newReferredId: string;
    newReferrerEmail: string;
    newReferredEmail: string;
    filterReferrerId: string;
    filterReferredId: string;
    filterReferrerEmail: string;
    filterReferredEmail: string;
    suspended: string;
    stripeTransfer: string;
    markPaidStripe: string;
    filterStatus: string;
    allStatuses: string;
    payableOnly: string;
    exportCsv: string;
    refresh: string;
    markPaid: string;
    payoutRef: string;
    payoutRefPlaceholder: string;
    referrer: string;
    referred: string;
    invoice: string;
  };
  footer: {
    rights: string;
  };
  common: {
    save: string;
    cancel: string;
    delete: string;
    edit: string;
    create: string;
    search: string;
    loading: string;
    noResults: string;
    confirm: string;
    back: string;
    next: string;
    close: string;
    yes: string;
    no: string;
    actions: string;
    status: string;
    name: string;
    description: string;
    date: string;
    type: string;
    active: string;
    inactive: string;
    enabled: string;
    disabled: string;
    selectLanguage: string;
    irreversibleAction: string;
    confirmDeletePrefix: string;
    errorWhileDeleting: string;
    deleteInProgress: string;
    deletePermanently: string;
  };

  dashboard: {
    loadStatsError: string;

    cards: {
      indexedMediaTitle: string;
      indexedMediaDescription: string;
      embeddingsTitle: string;
      embeddingsDescription: string;
      trackedStatusesTitle: string;
      trackedStatusesDescription: string;
      linkedCoursesTitle: string;
      linkedCoursesDescription: string;
    };

    recent: {
      title: string;
      description: string;
      table: {
        title: string;
        status: string;
        course: string;
        date: string;
      };
      empty: string;
    };

    activity: {
      title: string;
      totalDescription: string;
    };

    statuses: {
      title: string;
      empty: string;
    };
  };

  agencyDashboard: {
    title: string;
    subtitle: string;
    loading: string;
    error: string;
    notAgency: string;
    upgradeButton: string;
    pooledQuotas: string;
    pooledQuotasDescription: string;
    unlimited: string;
    thisMonth: string;
    items: string;
    workspace: string;
    workspaces: string;
    plan: string;
    preview: string;
    production: string;
    
    globalMetrics: {
      title: string;
      agents: string;
      storage: string;
      workspaces: string;
      conversations: string;
      knowledge: string;
      of: string;
    };

    workspacesList: {
      title: string;
      name: string;
      agents: string;
      storage: string;
      conversations: string;
      knowledgeItems: string;
      createdAt: string;
      mode: string;
      preview: string;
      production: string;
    };
  };

  knowledges: {
    tagline: string;
    collections: string;
    stats: string;
    syncs: string;

    panel: {
      orphanTitle: string;
      contentsOfPrefix: string;
      allContents: string;
      contentCount: string;
    };

    collectionsSidebar: {
      allContents: string;
      withoutCollection: string;
      newCollection: string;
      manual: string;
      wordpress: string;
      deleteCollectionTitle: string;
      deleteCollectionWarning: string;
    };

    collectionCreate: {
      title: string;
      subtitle: string;
      collectionTitleLabel: string;
      placeholder: string;
      titleRequired: string;
      creationError: string;
      creating: string;
      create: string;
      tipsTitle: string;
      tip1: string;
      tip2: string;
      tip3: string;
      kbLanguageLabel: string;
      kbLanguageHint: string;
    };

    kbContentLanguage: {
      label: string;
      hint: string;
      autoOption: string;
      langFr: string;
      langEn: string;
      langEs: string;
      langDe: string;
      langIt: string;
      langPt: string;
      langNl: string;
      langZhHans: string;
      sidebarTitle: string;
    };

    contentsPanel: {
      allStatuses: string;
      indexed: string;
      transcribed: string;
      pending: string;
      transcribing: string;
      indexing: string;
      inError: string;
      addContentShort: string;
      emptyTitle: string;
      emptyOrphan: string;
      emptyDefault: string;
      addFirstContent: string;
      deleteContentTitle: string;
      deleteContentWarning: string;
    };

    contentCard: {
      indexedAtPrefix: string;
      viewDetails: string;
      reindexClassic: string;
      alreadyLLMSegmented: string;
      llmSegmentation: string;
      forceTranscribe: string;
      yesterday: string;
      justNow: string;
      minutesAgo: string;
      hoursAgo: string;
      daysAgo: string;
    };

    contentDetail: {
      titleFallback: string;
      cannotLoadDetails: string;
      collection: string;
      withoutCollection: string;
      move: string;
      currentlyInPrefix: string;
      categories: string;
      course: string;
      chunks: string;
      embeddings: string;
      file: string;
      size: string;
      mb: string;
      embeddingsByCategory: string;
      transcription: string;
      characters: string;
      language: string;
      noTranscription: string;
      transcriptionUnavailable: string;
      downloadTranscription: string;
      downloadTxt: string;
      reindex: string;
      llmSegmentation: string;
      forceTranscribe: string;
    };

    statsDrawer: {
      title: string;
      subtitle: string;
      collections: string;
      contents: string;
      total: string;
      manuals: string;
      wordpress: string;
      orphanContents: string;
      ready: string;
      indexed: string;
      transcribed: string;
      processing: string;
      pending: string;
      errors: string;
      globalHealth: string;
      usableContents: string;
      healthHint: string;
      byStatus: string;
    };

    wpImport: {
      title: string;
      chooseContentType: string;
      selectContentsPrefix: string;
      confirmImport: string;
      importing: string;
      completed: string;
      error: string;
      availableQuota: string;
      credits: string;
      selected: string;
      continue: string;
      quotaEnough: string;
      quotaNotEnough: string;
      back: string;
      launching: string;
      importN: string;
      editSelection: string;
      importSummary: string;
      selectedContents: string;
      totalChars: string;
      requiredCredits: string;
      creditsAfter: string;
      quotaAfter: string;
      importPossible: string;
      quotaExceeded: string;
      importOptions: string;
      destinationCollection: string;
      autoCreate: string;
      autoCreateFromCourses: string;
      items: string;
      item: string;
      notAvailable: string;
      selectAll: string;
      none: string;
      availableSuffix: string;
      noTitle: string;
      modified: string;
      imported: string;
      charCount: string;
      approxChars: string;
      loadMore: string;
      cancelImport: string;
      importWithErrors: string;
      importDone: string;
      importedSuccess: string;
      success: string;
      failed: string;
    };

    upload: {
      title: string;
      description: string;
      close: string;
      collection: string;
      course: string;
      choose: string;
      advice: string;
      courseHelp: string;
      dropzoneTitle: string;
      formats: string;
      filesSelected: string;
      uploading: string;
      completed: string;
      upload: string;
      reset: string;
      footer: string;
      errorLoadSubjects: string;
      errorSelectFile: string;
      success: string;
      partialSuccess: string;
      mb: string;
    };
  };

  agents: {
    title: string;
    tagline: string;
    statsDrawerTitle: string;
    statsDrawerSubtitle: string;
    createAgent: string;
    statistics: string;
    loading: string;
    noAgents: string;
    lastUpdated: string;
    quotaBadge: {
      active: string;
      max: string;
      quotaReached: string;
    };
    deleteModal: {
      title: string;
      warning: string;
      linkedSubjectsWarning: string;
      noSubjectsWarning: string;
    };
    agentCard: {
      active: string;
      inactive: string;
      messages: string;
      docs: string;
      ai: string;
      updated: string;
      useInChat: string;
      history: string;
      edit: string;
      deactivate: string;
      activate: string;
      mcp: string;
      assignEmail: string;
      changeIcon: string;
      uploading: string;
      delete: string;
      deleting: string;
    };
    stats: {
      activeAgents: string;
      activeAgentsDesc: string;
      activeAgentsEmpty: string;
      messagesSent: string;
      messagesRemaining: string;
      noLimit: string;
      globalQuota: string;
      limitLabel: string;
      unlimitedPlan: string;
      lastUpdate: string;
      noAgentYet: string;
      recentAgent: string;
      usageGlobal: string;
      messagesOrg: string;
      totalAgents: string;
      knowledgeBases: string;
      aiUsed: string;
      totalMessagesByAgents: string;
      globalQuotaTitle: string;
      messagesAllowed: string;
      utilization: string;
      unlimited: string;
      remainingMessages: string;
      lastAgentCreated: string;
      mostActiveAgents: string;
      top5Period: string;
      noMessagesYet: string;
      maxLabel: string;
      noCap: string;
      docsSuffix: string;
      messagesSuffix: string;
    };
    sandbox: {
      title: string;
      subtitle: string;
      quotaPreserved: string;
      settings: string;
      playgroundTitle: string;
      playgroundSubtitle: string;
      close: string;
      save: string;
      saving: string;
    };
    errors: {
      loadAgents: string;
      createAgent: string;
      updateAgent: string;
      deleteAgent: string;
      toggleActivation: string;
      quotaReached: string;
      uploadIcon: string;
    };
    teams: {
      header: string;
      allAgents: string;
      noTeam: string;
      newTeam: string;
      deleteTitle: string;
      deleteWarning: string;
      createModal: {
        title: string;
        subtitle: string;
        close: string;
        nameLabel: string;
        namePlaceholder: string;
        creating: string;
        create: string;
        errorRequired: string;
        errorCreate: string;
        tipsTitle: string;
        tip1: string;
        tip2: string;
        tip3: string;
      };
    };
    modelPicker: {
      browse: string;
      title: string;
      search: string;
      tabOllama: string;
      tabOpenai: string;
      tabAnthropic: string;
      emptyTab: string;
      noMatch: string;
      apply: string;
      cancel: string;
      loading: string;
    };
    llmCatalog: {
      title: string;
      subtitle: string;
      save: string;
      saving: string;
      loadError: string;
      saveError: string;
      byokNote: string;
      sortLabel: string;
      enabledLabel: string;
      colModel: string;
      noKeyBadge: string;
      workspaceTab: string;
      workspaceTabDesc: string;
      errForbidden: string;
      errPayload: string;
      errUnknownModel: string;
    };
    agentEditor: {
      titleNew: string;
      titleEdit: string;
      cancel: string;
      saving: string;
      save: string;
      create: string;
      tabGeneral: string;
      tabKnowledge: string;
      tabMemory: string;
      sectionGeneral: string;
      nameLabel: string;
      namePlaceholder: string;
      subtitleLabel: string;
      subtitlePlaceholder: string;
      iconLabel: string;
      chooseImage: string;
      instructionsLabel: string;
      instructionsPlaceholder: string;
      hideTemplates: string;
      changeTemplate: string;
      messageLimitLabel: string;
      messageLimitPlaceholder: string;
      messageLimitHelp: string;
      sectionAI: string;
      modelLabel: string;
      modelDefault: string;
      topKLabel: string;
      topKHelp: string;
      rerankLabel: string;
      rerankHelp: string;
      strictLabel: string;
      strictHelp: string;
      sectionTeam: string;
      teamLabel: string;
      teamNone: string;
      sectionAdminPrompt: string;
      adminPromptLabel: string;
      adminPromptDefault: string;
      adminPromptHelp: string;
      sectionKnowledge: string;
      knowledgeHelp: string;
      noKnowledge: string;
      noKnowledgeHint: string;
      selected: string;
      sectionMemory: string;
      memoryBusiness: string;
      memoryBusinessHelp: string;
      memoryEndUser: string;
      memoryEndUserHelp: string;
      scopesTitle: string;
      noScopes: string;
      scopeMemoryLink: string;
      scopeNoneSelected: string;
      scopeSelected: string;
      memoryPageHint: string;
      errorNameRequired: string;
      errorSave: string;
      agentTypeLabel: string;
      agentTypePlaceholder: string;
      templateRecommended: string;
      templateOthers: string;
      templateCount: string;
      templateNoAvailable: string;
      templateTipTitle: string;
      templateTipBody: string;
      levelBasic: string;
      levelAdvanced: string;
      levelPremium: string;
      badgeRecommended: string;
      badgeUsed: string;
      btnPreview: string;
      btnHide: string;
      btnUse: string;
      labelPopularity: string;
    };
  };

  conversations: {
    title: string;
    historyForAgent: string;
    backToAgents: string;
    loading: string;
    errorLoading: string;
    noConversations: string;
    searchPlaceholder: string;
    filters: string;
    hideFilters: string;
    allSources: string;
    whatsApp: string;
    widgetExt: string;
    widgetInt: string;
    filteredBy: string;
    allAgents: string;
    allUsers: string;
    allPeriods: string;
    today: string;
    thisWeek: string;
    thisMonth: string;
    allMessages: string;
    short: string;
    medium: string;
    long: string;
    sortBy: {
      updatedAt: string;
      createdAt: string;
      title: string;
    };
    sortOrder: {
      desc: string;
      asc: string;
    };
    favoritesOnly: string;
    resetFilters: string;
    realtime: string;
    conversationsCount: string;
    agent: string;
    messages: string;
    sources: {
      whatsapp: string;
      widgetExternal: string;
      widgetInternal: string;
    };
    humanTakeover: {
      human: string;
      auto: string;
      takeover: string;
      release: string;
      takeoverTitle: string;
      releaseTitle: string;
    };
    favorite: {
      add: string;
      remove: string;
    };
    delete: {
      title: string;
      confirm: string;
      error: string;
    };
    resume: {
      title: string;
      success: string;
    };
    toast: {
      newMessage: string;
      takeoverActivated: string;
      agentReactivated: string;
      autoTakeover: string;
    };
    time: {
      justNow: string;
      minutesAgo: string;
      hoursAgo: string;
      daysAgo: string;
    };
  };

  memory: {
    title: string;
    tagline: string;
    tabs: {
      facts: string;
      scopes: string;
      categories: string;
    };
    filters: {
      search: string;
      searchPlaceholder: string;
      scope: string;
      allScopes: string;
      category: string;
      allCategories: string;
    };
    buttons: {
      newFact: string;
      newScope: string;
    };
    empty: {
      facts: string;
    };
    badges: {
      verified: string;
      redacted: string;
      system: string;
      business: string;
      endUser: string;
    };
    labels: {
      scope: string;
      source: string;
      used: string;
      times: string;
      facts: string;
      ttl: string;
      days: string;
      permanent: string;
    };
    tooltips: {
      edit: string;
      delete: string;
    };
    confirm: {
      deleteScope: string;
      deleteFact: string;
    };
    errors: {
      delete: string;
      loadData: string;
      loadFacts: string;
    };
  };

  endUsers: {
    title: string;
    tagline: string;
    searchPlaceholder: string;
    search: string;
    newClient: string;
    stats: {
      totalClients: string;
      active7d: string;
      withEmail: string;
    };
    empty: {
      noResults: string;
      noClients: string;
    };
    labels: {
      id: string;
      username: string;
      created: string;
      seen: string;
      never: string;
    };
    tooltips: {
      stats: string;
      export: string;
      anonymize: string;
      delete: string;
    };
    confirm: {
      delete: string;
      deleteWarning: string;
      anonymize: string;
      anonymizeWarning: string;
    };
    errors: {
      loadStats: string;
      export: string;
      delete: string;
      anonymize: string;
    };
    modal: {
      statsTitle: string;
      memoryScopes: string;
      memoryFacts: string;
      externalId: string;
      email: string;
      createdAt: string;
      lastActivity: string;
      close: string;
      newClientTitle: string;
      newClientInfo: string;
      newClientApi: string;
    };
  };

  email: {
    title: string;
    tagline: string;
    observeTitle: string;
    observeBody: string;
    messagesModalHint: string;
    detailReplySentAt: string;
    refresh: string;
    newConnection: string;
    connections: string;
    noConnections: string;
    connectionsCount: string;
    delete: {
      title: string;
      irreversible: string;
      close: string;
      confirm: string;
      warning: string;
      cancel: string;
      deleting: string;
      deletePermanently: string;
    };
    card: {
      processed: string;
      interval: string;
      lastCheck: string;
      totemiumActivity: string;
      statReceivedShort: string;
      statRepliedShort: string;
      statPendingShort: string;
      enabled: string;
      disabled: string;
      auto: string;
      manual: string;
      messages: string;
      patterns: string;
      settings: string;
      delete: string;
    };
    empty: {
      title: string;
      description: string;
      addConnection: string;
    };
    providers: {
      gmail: string;
      outlook: string;
      imap: string;
    };
    editor: {
      titleNew: string;
      titleEdit: string;
      cancel: string;
      saving: string;
      save: string;
      create: string;
      sectionIdentity: string;
      emailLabel: string;
      displayNameLabel: string;
      displayNamePlaceholder: string;
      agentLabel: string;
      agentNone: string;
      agentHelp: string;
      sectionImap: string;
      imapHostLabel: string;
      imapHostPlaceholder: string;
      smtpHostLabel: string;
      smtpHostPlaceholder: string;
      portLabel: string;
      useTls: string;
      testReenterCredentials: string;
      testBtn: string;
      testing: string;
      sectionAuth: string;
      usernameLabel: string;
      usernamePlaceholder: string;
      usernameUnchanged: string;
      keepCurrentHint: string;
      passwordLabel: string;
      sectionSettings: string;
      checkIntervalLabel: string;
      enabledLabel: string;
      autoReplyLabel: string;
      sectionDomain: string;
      infoTitle: string;
      infoPort993: string;
      infoPort587: string;
      infoGmail: string;
      infoGmailAppPassword: string;
      infoImap: string;
      errorEmailRequired: string;
      errorImapRequired: string;
      errorUsernameRequired: string;
      errorPasswordRequired: string;
    };
  };

  workflows: {
    title: string;
    tagline: string;
    newWorkflow: string;
    createWorkflow: string;
    searchPlaceholder: string;
    allAgents: string;
    allStatuses: string;
    active: string;
    inactive: string;
    delete: {
      title: string;
      irreversible: string;
      close: string;
      confirm: string;
      cancel: string;
      delete: string;
    };
    errors: {
      load: string;
      toggle: string;
      delete: string;
    };
    stats: {
      activeWorkflows: string;
      activeDescription: string;
      executionsToday: string;
      executionsDescription: string;
      successRate: string;
      successDescription: string;
      totalWorkflows: string;
      totalDescription: string;
    };
    empty: {
      title: string;
      noResults: string;
      createFirst: string;
    };
    card: {
      agent: string;
      executions: string;
      success: string;
      failures: string;
      nextRun: string;
      view: string;
      edit: string;
      delete: string;
      enable: string;
      disable: string;
    };
    connectors: {
      schedule: string;
      manual: string;
      webhook: string;
      email: string;
      email_imap: string;
      rss_feed: string;
      slack: string;
      webhook_out: string;
      unknown: string;
    };
  };
}
